import comp from '../components/barrel';
import svg from '../js/svg';
import U from '../js/utils';
import config from '../js/config';

export default {
  application_uuid: null,
  underwriters: null,
  logApplicationViewUuid: null,
  flaggedYn: false,
  loggedInRoleText: null,
  overviewAdvisorTimeout: null,
  async prepare() {
    this.application_uuid =
      this.vars?.application_uuid ||
      thsPage?.vars?.application_uuid ||
      thsPage?.application_uuid;

    const vars = {};
    vars.application_uuid = this.application_uuid;
    this.recipe.methods.push(await O.mPOST('application/get-app-summary', vars));
    // Call underwriters endpoint - will be used if additional products section is shown
    this.recipe.methods.push(await O.mPOST('communal/underwriters', vars));

    const {value: loggedInUuid} = await O.getCookie('ewttgpvwwkf');
    if (loggedInUuid) {
      this.recipe.methods.push(
        await O.mPOST('users/get-user-details', {target_user_uuid: loggedInUuid})
      );
    }
  },
  async render() {
    const rec = this.recipe.methods;

    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    // Store underwriters data if available and app summary was successful
    const appSummaryResponse = data['application/get-app-summary'];
    if (appSummaryResponse && appSummaryResponse.status === 'OK' && data['communal/underwriters'] && data['communal/underwriters'].data) {
      this.underwriters = data['communal/underwriters'].data;
    }
    const userDetails = data['users/get-user-details']?.data;
    this.loggedInRoleText = userDetails?.role_text || null;
    await this.loadPage(data);
  },
  async loadPage(data) {
    const response = data[`application/get-app-summary`];
    if (!response || !response.data) {
      return;
    }
    
    const appSummaryData = response.data;

    // STATUS -------
    const status_row = U.id('status_row');
    status_row.innerHTML = ''; // Clear any existing content
    status_row.style.display = 'flex';
    status_row.style.alignItems = 'center';
    status_row.style.gap = '0.5rem';
    status_row.style.flexWrap = 'nowrap';
    let statusText = await comp.statusTag(appSummaryData.status);
    status_row.appendChild(statusText);

    const viewUuid = appSummaryData.log_application_view_uuid;
    this.logApplicationViewUuid =
      viewUuid != null && String(viewUuid).trim() !== '' ? String(viewUuid).trim() : null;
    this.flaggedYn =
      appSummaryData.flagged_yn === true ||
      appSummaryData.flagged_yn === 'true' ||
      appSummaryData.flagged_yn === 1;
    this.renderApplicationViewFlag(status_row);

    const importedNotesSection = U.id('imported_notes_section');
    importedNotesSection.innerHTML = '';
    importedNotesSection.className = 'min-w-0';
    const importNotesVal = appSummaryData.importnotes ?? appSummaryData.import_notes;
    const hasImportNotes =
      importNotesVal != null && String(importNotesVal).trim() !== '';
    const importNotesHeading = U.id('import_notes_heading');
    if (importNotesHeading) {
      importNotesHeading.style.display = hasImportNotes ? '' : 'none';
    }
    if (hasImportNotes) {
      const notesBox = document.createElement('div');
      notesBox.className = 'border border-gray-200 rounded-md p-3 bg-gray-50';
      const notesBody = document.createElement('p');
      notesBody.className = 'text-sm text-gray-700 whitespace-pre-wrap break-words m-0';
      notesBody.textContent = String(importNotesVal);
      notesBox.appendChild(notesBody);
      importedNotesSection.appendChild(notesBox);
    }

    const statusActions = U.id('status_actions');
    statusActions.innerHTML = '';
    if (appSummaryData.can_cancellyn) {
      const cancelButton = document.createElement('button');
      cancelButton.className = 'btn-outline px-4 max-w-none';
      cancelButton.textContent = 'Cancel';
      cancelButton.id = 'cancelAppButton';
      cancelButton.setAttribute('onclick', 'thsTab.showCancelInput()');
      cancelButton.style.boxSizing = 'border-box';
      cancelButton.style.setProperty('border', '2px solid #dc2626', 'important');
      cancelButton.style.setProperty('color', '#b91c1c', 'important');
      cancelButton.style.setProperty('background-color', '#fff', 'important');
      cancelButton.addEventListener('mouseenter', () => {
        cancelButton.style.setProperty('border-color', '#991b1b', 'important');
        cancelButton.style.setProperty('background-color', '#fef2f2', 'important');
      });
      cancelButton.addEventListener('mouseleave', () => {
        cancelButton.style.setProperty('border', '2px solid #dc2626', 'important');
        cancelButton.style.setProperty('background-color', '#fff', 'important');
      });
      statusActions.appendChild(cancelButton);
    }

    // ADVISOR -------
    const advisor_row = U.id('advisor_row');
    advisor_row.innerHTML = ''; // Clear any existing content
    let nameText = comp.displayText('advisorName', appSummaryData.advisor, 'Name');
    let codeText = comp.displayText('advisorCode', 'TBC', 'Code');
    let tell_nrText = comp.displayText('advisorTel', appSummaryData.advisor_cell_nr, 'Tel no.');
    let email_addressText = comp.displayText('advisorEmail', appSummaryData.advisor_email_address, 'Email');
    advisor_row.appendChild(nameText);
    advisor_row.appendChild(codeText);
    advisor_row.appendChild(tell_nrText);
    advisor_row.appendChild(email_addressText);

    await this.setupOverviewChangeAdvisorBar();

    // WILL DETAILS -------
    const willDetails_row = U.id('willDetails_row');
    willDetails_row.innerHTML = ''; // Clear any existing content
    willDetails_row.className = 'res-grid-cols-4';

    const willDetails_import_row = U.id('willDetails_import_row');
    willDetails_import_row.innerHTML = '';
    willDetails_import_row.className = 'res-grid-cols-4';

    const willDetails_dates_row = U.id('willDetails_dates_row');
    willDetails_dates_row.innerHTML = '';
    willDetails_dates_row.className = 'res-grid-cols-4';

    const willDetails_history_row = U.id('willDetails_history_row');
    willDetails_history_row.innerHTML = '';
    willDetails_history_row.className = 'res-grid-cols-4';

    const formatDateForInput = (dateValue) => {
      if (!dateValue) return '';
      if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
        return dateValue;
      }
      if (typeof dateValue === 'string' && dateValue.includes('T')) {
        return dateValue.split('T')[0];
      }
      if (dateValue instanceof Date) {
        const year = dateValue.getFullYear();
        const month = String(dateValue.getMonth() + 1).padStart(2, '0');
        const day = String(dateValue.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
      try {
        const date = new Date(dateValue);
        if (!isNaN(date.getTime())) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        }
      } catch (e) {
        // If parsing fails, return empty string
      }
      return '';
    };

    // Will number is always read-only
    // Use h_will_id if not null, otherwise fall back to will_nr or 'TBC'
    const willNumberValue = appSummaryData.h_will_id != null ? appSummaryData.h_will_id : (appSummaryData.will_nr || 'TBC');
    let will_nrText = comp.displayText('will_nr', willNumberValue, 'Will number');
    
    // Check if imported will number can be edited
    const canEditImportedWillNumber = appSummaryData.edit_will_number_yn === true || appSummaryData.edit_will_number_yn === 'true';
    // Get imported will number value from API response
    const importedWillNumberValue = appSummaryData.importwillnumber != null ? String(appSummaryData.importwillnumber) : '';
    
    let importWillNumberText;
    if (canEditImportedWillNumber) {
      // Use comp.inputText which handles values correctly - pass empty label since we'll add our own
      const inputTextElement = await comp.inputText('importWillNumber', importedWillNumberValue, '', 0);
      const importedWillNumberInput = inputTextElement.querySelector('#importWillNumber');
      
      // Set input width and ensure value is set
      if (importedWillNumberInput) {
        importedWillNumberInput.style.width = '120px';
        importedWillNumberInput.style.height = '32px';
        importedWillNumberInput.style.boxSizing = 'border-box';
        // Explicitly set value again to ensure it's there
        importedWillNumberInput.value = importedWillNumberValue;
      }
      
      // Create container for input and button
      const importedWillNumberContainer = document.createElement('div');
      importedWillNumberContainer.style.display = 'flex';
      importedWillNumberContainer.style.flexDirection = 'column';
      importedWillNumberContainer.style.gap = '0.5rem';
      
      // Add label at top
      const importedWillNumberLabel = document.createElement('label');
      importedWillNumberLabel.textContent = 'Imported Will number';
      importedWillNumberLabel.className = 'block text-left mb-2 font-medium';
      importedWillNumberContainer.appendChild(importedWillNumberLabel);
      
      // Create vertical container for input and button (button below input)
      const inputButtonContainer = document.createElement('div');
      inputButtonContainer.style.display = 'flex';
      inputButtonContainer.style.flexDirection = 'column';
      inputButtonContainer.style.gap = '0.25rem';
      inputButtonContainer.style.alignItems = 'flex-start';
      
      // Remove label from input-group if it exists, then append the input element
      const inputGroup = inputTextElement.querySelector('.input-group');
      if (inputGroup) {
        const inputGroupLabel = inputGroup.querySelector('label');
        if (inputGroupLabel) {
          inputGroupLabel.remove();
        }
        // Append the input element directly (it's already in inputGroup, but we want just the input)
        inputButtonContainer.appendChild(importedWillNumberInput);
      } else {
        // Fallback: just append the input if inputGroup not found
        inputButtonContainer.appendChild(importedWillNumberInput);
      }
      
      // Add update button below the input
      const importedWillNumberUpdateButton = document.createElement('button');
      importedWillNumberUpdateButton.textContent = 'Update';
      importedWillNumberUpdateButton.className = 'btn';
      importedWillNumberUpdateButton.style.height = '32px';
      importedWillNumberUpdateButton.style.boxSizing = 'border-box';
      importedWillNumberUpdateButton.setAttribute('onclick', 'thsTab.updateImportedWillNumber()');
      inputButtonContainer.appendChild(importedWillNumberUpdateButton);
      
      importedWillNumberContainer.appendChild(inputButtonContainer);
      
      importWillNumberText = importedWillNumberContainer;
    } else {
      // Use read-only display text
      importWillNumberText = comp.displayText('importWillNumber', importedWillNumberValue || '', 'Imported Will number');
    }
    let testamentText = comp.displayText('testament', appSummaryData.testament, 'Testament');

    let crossIcon = svg.crossCircle();
    let tickIcon = svg.tickCircle();
    let will_typeText = comp.displayText('app_type', 'Amended will', '', appSummaryData.app_type === 'Amended will' ? tickIcon : crossIcon);
    let offshoreText = comp.displayText('offshore_will', 'Offshore will', '', appSummaryData.offshore_will ? tickIcon : crossIcon);

    // Create a container for the last two items to stack vertically in the 4th column
    const stackedContainer = U.divAtt('div', 'class', 'flex flex-col');
    stackedContainer.appendChild(will_typeText);
    stackedContainer.appendChild(offshoreText);

    willDetails_row.appendChild(will_nrText);
    willDetails_row.appendChild(testamentText);
    willDetails_row.appendChild(stackedContainer);

    willDetails_import_row.appendChild(importWillNumberText);

    const reviewedWithClientValue = appSummaryData.reviewed_with_client;
    const reviewedWithClientIso = (() => {
      if (reviewedWithClientValue == null || reviewedWithClientValue === '') {
        return null;
      }
      const str = String(reviewedWithClientValue).trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
        return str;
      }
      if (str.includes('T')) {
        return str.split('T')[0];
      }
      return null;
    })();
    const lastReviewedDateElement = await comp.inputDate('lastReviewedWithClient', '', '', 0);
    const lastReviewedInput = lastReviewedDateElement.querySelector('#lastReviewedWithClient');
    if (lastReviewedInput) {
      lastReviewedInput.style.height = '32px';
      lastReviewedInput.style.boxSizing = 'border-box';
    }

    const lastReviewedContainer = document.createElement('div');
    lastReviewedContainer.style.display = 'flex';
    lastReviewedContainer.style.flexDirection = 'column';
    lastReviewedContainer.style.gap = '0.5rem';

    const lastReviewedLabel = document.createElement('label');
    let lastReviewedLabelText = 'Last reviewed with client';
    if (reviewedWithClientIso) {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const [year, monthNum, day] = reviewedWithClientIso.split('-');
      const month = months[parseInt(monthNum, 10) - 1];
      lastReviewedLabelText += ` ( currently ${year}/${month}/${parseInt(day, 10)})`;
    }
    lastReviewedLabel.textContent = lastReviewedLabelText;
    lastReviewedLabel.className = 'block text-left mb-2 font-medium';
    lastReviewedContainer.appendChild(lastReviewedLabel);

    const lastReviewedInputButtonContainer = document.createElement('div');
    lastReviewedInputButtonContainer.style.display = 'flex';
    lastReviewedInputButtonContainer.style.flexDirection = 'column';
    lastReviewedInputButtonContainer.style.gap = '0.25rem';
    lastReviewedInputButtonContainer.style.alignItems = 'flex-start';

    const lastReviewedInputGroup = lastReviewedDateElement.querySelector('.input-group');
    if (lastReviewedInputGroup) {
      const lastReviewedInputGroupLabel = lastReviewedInputGroup.querySelector('label');
      if (lastReviewedInputGroupLabel) {
        lastReviewedInputGroupLabel.remove();
      }
      lastReviewedInputButtonContainer.appendChild(lastReviewedInput);
    } else if (lastReviewedInput) {
      lastReviewedInputButtonContainer.appendChild(lastReviewedInput);
    }

    const lastReviewedUpdateButton = document.createElement('button');
    lastReviewedUpdateButton.textContent = 'Update';
    lastReviewedUpdateButton.className = 'btn';
    lastReviewedUpdateButton.style.height = '32px';
    lastReviewedUpdateButton.style.boxSizing = 'border-box';
    lastReviewedUpdateButton.setAttribute('onclick', 'thsTab.updateLastReviewedWithClient()');
    lastReviewedInputButtonContainer.appendChild(lastReviewedUpdateButton);

    lastReviewedContainer.appendChild(lastReviewedInputButtonContainer);
    willDetails_import_row.appendChild(lastReviewedContainer);

    await this.renderInviteClientFulfillment(appSummaryData);

    // WILL HISTORY FIELDS (added to Will details section)
    const captureWillHistory = appSummaryData.capture_will_history_yn === true || appSummaryData.capture_will_history_yn === 'true';
    if (captureWillHistory) {
      // Determine if fields should be editable
      const importWillDatesYN = appSummaryData.import_will_dates_yn === true || appSummaryData.import_will_dates_yn === 'true';
      const receivedDateIsNull = appSummaryData.received_date == null;
      const importWillNumberIsSet =
        appSummaryData.importwillnumber != null &&
        String(appSummaryData.importwillnumber).trim() !== '';
      const showAsInputs = importWillDatesYN || receivedDateIsNull || importWillNumberIsSet;
      
      // Received date
      if (showAsInputs) {
        const receivedDateFormatted = formatDateForInput(appSummaryData.received_date);
        const receivedDateInput = await comp.inputDate('willHistoryReceivedDate', receivedDateFormatted, 'Received date', 0);
        willDetails_dates_row.appendChild(receivedDateInput);
      } else {
        const receivedDateText = comp.displayText('willHistoryReceivedDate', appSummaryData.received_date ? await U.formatDate(appSummaryData.received_date) : '', 'Received date');
        willDetails_dates_row.appendChild(receivedDateText);
      }
      
      // Signed date
      if (showAsInputs) {
        const signedDateFormatted = formatDateForInput(appSummaryData.signed_date);
        const signedDateInput = await comp.inputDate('willHistorySignedDate', signedDateFormatted, 'Signed date', 0);
        willDetails_dates_row.appendChild(signedDateInput);
      } else {
        const signedDateText = comp.displayText('willHistorySignedDate', appSummaryData.signed_date ? await U.formatDate(appSummaryData.signed_date) : '', 'Signed date');
        willDetails_dates_row.appendChild(signedDateText);
      }
      
      // Verification date
      if (showAsInputs) {
        const verificationDateFormatted = formatDateForInput(appSummaryData.verification_date);
        const verificationDateInput = await comp.inputDate('willHistoryVerificationDate', verificationDateFormatted, 'Verification date', 0);
        willDetails_dates_row.appendChild(verificationDateInput);
      } else {
        const verificationDateText = comp.displayText('willHistoryVerificationDate', appSummaryData.verification_date ? await U.formatDate(appSummaryData.verification_date) : '', 'Verification date');
        willDetails_dates_row.appendChild(verificationDateText);
      }
      
      // Filing number (always display only)
      const filingNumberText = comp.displayText('willHistoryFilingNumber', appSummaryData.filing_number || '', 'Filing number');
      willDetails_dates_row.appendChild(filingNumberText);
      
      // Will notes
      if (showAsInputs) {
        const willNotesTextarea = await comp.textarea('willHistoryNotes', appSummaryData.will_notes || '', 'Will notes', 0);
        willDetails_history_row.appendChild(willNotesTextarea);
      } else {
        const willNotesText = comp.displayText('willHistoryNotes', appSummaryData.will_notes || '', 'Will notes');
        willDetails_history_row.appendChild(willNotesText);
      }
      
      // Add Update button below Will notes (only if fields are editable)
      if (showAsInputs) {
        const updateButtonContainer = document.createElement('div');
        updateButtonContainer.style.marginTop = '0.5rem';
        updateButtonContainer.style.marginBottom = '2rem';
        
        const updateButton = document.createElement('button');
        updateButton.textContent = 'Update';
        updateButton.className = 'btn';
        updateButton.setAttribute('onclick', 'thsTab.updateWillHistory()');
        
        updateButtonContainer.appendChild(updateButton);
        willDetails_history_row.appendChild(updateButtonContainer);
      }
    }

    // PARTIES -------
    const parties_row = U.id('parties_row');
    parties_row.innerHTML = ''; // Clear any existing content
    parties_row.className = ''; // Remove res-grid-cols-4 constraint
    parties_row.style.overflowX = 'auto'; // Allow horizontal scrolling if needed
    parties_row.style.width = '100%'; // Ensure container takes full width
    
    // Create table for Parties - adjust width for 6 columns if change_parties_yn is true
    const partiesChangePartiesYN = appSummaryData.change_parties_yn === true;
    // Count how many parties have user_uuid (non-null)
    const partiesPartyCount = [
      appSummaryData.party1_user_uuid,
      appSummaryData.party2_user_uuid,
      appSummaryData.party3_user_uuid,
      appSummaryData.party4_user_uuid,
      appSummaryData.party5_user_uuid
    ].filter(uuid => uuid !== null && uuid !== undefined).length;
    // Only show delete icon if change_parties_yn is true AND there are 2 or more parties
    const partiesShowDeleteIcon = partiesChangePartiesYN && partiesPartyCount > 1;
    const partiesColumnCount = partiesShowDeleteIcon ? 6 : 5;
    const partiesColumnWidth = Math.floor(1200 / partiesColumnCount);
    const partiesTable = U.divAtt('table');
    partiesTable.style.width = '1200px';
    partiesTable.style.tableLayout = 'fixed'; // Use fixed layout for consistent column widths
    partiesTable.style.outline = 'none'; // Remove default outline
    partiesTable.style.border = 'none'; // Remove all borders
    partiesTable.style.borderCollapse = 'collapse'; // Collapse borders to reduce spacing
    partiesTable.style.borderSpacing = '0'; // Remove spacing between cells
    
    // HEADER
    const partiesThead = U.divAtt('thead');
    partiesThead.style.backgroundColor = 'transparent'; // Remove blue background
    partiesThead.style.color = '#000'; // Set text color to black
    const partiesHeadRow = partiesThead.insertRow();
    
    const partiesNameHeader = partiesHeadRow.insertCell(0);
    partiesNameHeader.innerHTML = 'Name';
    partiesNameHeader.style.width = `${partiesColumnWidth}px`;
    partiesNameHeader.style.verticalAlign = 'top';
    partiesNameHeader.style.fontSize = '0.875rem'; // text-sm
    partiesNameHeader.style.fontWeight = '300'; // font-light
    partiesNameHeader.style.letterSpacing = '0.025em'; // tracking-wide
    partiesNameHeader.style.color = '#374151'; // grey-dark
    const partiesIdHeader = partiesHeadRow.insertCell(1);
    partiesIdHeader.innerHTML = 'ID';
    partiesIdHeader.style.width = `${partiesColumnWidth}px`;
    partiesIdHeader.style.verticalAlign = 'top';
    partiesIdHeader.style.fontSize = '0.875rem';
    partiesIdHeader.style.fontWeight = '300';
    partiesIdHeader.style.letterSpacing = '0.025em';
    partiesIdHeader.style.color = '#374151';
    const partiesStatusHeader = partiesHeadRow.insertCell(2);
    partiesStatusHeader.innerHTML = 'Status';
    partiesStatusHeader.style.width = `${partiesColumnWidth}px`;
    partiesStatusHeader.style.verticalAlign = 'top';
    partiesStatusHeader.style.fontSize = '0.875rem';
    partiesStatusHeader.style.fontWeight = '300';
    partiesStatusHeader.style.letterSpacing = '0.025em';
    partiesStatusHeader.style.color = '#374151';
    const partiesNotesHeader = partiesHeadRow.insertCell(3);
    partiesNotesHeader.innerHTML = 'Notes';
    partiesNotesHeader.style.width = `${partiesColumnWidth}px`;
    partiesNotesHeader.style.verticalAlign = 'top';
    partiesNotesHeader.style.fontSize = '0.875rem';
    partiesNotesHeader.style.fontWeight = '300';
    partiesNotesHeader.style.letterSpacing = '0.025em';
    partiesNotesHeader.style.color = '#374151';
    const partiesUpdateHeader = partiesHeadRow.insertCell(4);
    partiesUpdateHeader.innerHTML = '';
    partiesUpdateHeader.style.width = `${partiesColumnWidth}px`;
    partiesUpdateHeader.style.verticalAlign = 'top';
    
    // Add delete column header if showDeleteIcon is true
    if (partiesShowDeleteIcon) {
      const partiesDeleteHeader = partiesHeadRow.insertCell(5);
      partiesDeleteHeader.innerHTML = '';
      partiesDeleteHeader.style.width = `${partiesColumnWidth}px`;
      partiesDeleteHeader.style.verticalAlign = 'top';
    }
    
    partiesThead.appendChild(partiesHeadRow);
    partiesTable.appendChild(partiesThead);
    
    // BODY
    const partiesTbody = U.divAtt('tbody');
    partiesTbody.style.borderSpacing = '0'; // Remove spacing between rows
    
    // Helper function to get party ID (ID number or Passport number)
    const partiesGetPartyID = (partyData) => {
      return partyData.id_nr || partyData.passport_nr || '';
    };
    
    // Build array of parties with party number for identification
    // showStatusNotesUpdate: only show status/notes inputs and Update button when API returned party_status and party_notes for this party
    const partiesList = [];
    if (appSummaryData.party1_full_name) {
      const n = 1;
      partiesList.push({
        partyNumber: n,
        name: appSummaryData.party1_full_name,
        id: partiesGetPartyID({
          id_nr: appSummaryData.party1_id_nr,
          passport_nr: appSummaryData.party1_passport_nr
        }),
        status: appSummaryData.party1_party_status ?? '',
        notes: appSummaryData.party1_party_notes ?? '',
        user_uuid: appSummaryData.party1_user_uuid ?? null,
        showStatusNotesUpdate: Object.prototype.hasOwnProperty.call(appSummaryData, `party${n}_party_status`) && Object.prototype.hasOwnProperty.call(appSummaryData, `party${n}_party_notes`)
      });
    }
    if (appSummaryData.party2_full_name) {
      const n = 2;
      partiesList.push({
        partyNumber: n,
        name: appSummaryData.party2_full_name,
        id: partiesGetPartyID({
          id_nr: appSummaryData.party2_id_nr,
          passport_nr: appSummaryData.party2_passport_nr
        }),
        status: appSummaryData.party2_party_status ?? '',
        notes: appSummaryData.party2_party_notes ?? '',
        user_uuid: appSummaryData.party2_user_uuid ?? null,
        showStatusNotesUpdate: Object.prototype.hasOwnProperty.call(appSummaryData, `party${n}_party_status`) && Object.prototype.hasOwnProperty.call(appSummaryData, `party${n}_party_notes`)
      });
    }
    if (appSummaryData.party3_full_name) {
      const n = 3;
      partiesList.push({
        partyNumber: n,
        name: appSummaryData.party3_full_name,
        id: partiesGetPartyID({
          id_nr: appSummaryData.party3_id_nr,
          passport_nr: appSummaryData.party3_passport_nr
        }),
        status: appSummaryData.party3_party_status ?? '',
        notes: appSummaryData.party3_party_notes ?? '',
        user_uuid: appSummaryData.party3_user_uuid ?? null,
        showStatusNotesUpdate: Object.prototype.hasOwnProperty.call(appSummaryData, `party${n}_party_status`) && Object.prototype.hasOwnProperty.call(appSummaryData, `party${n}_party_notes`)
      });
    }
    if (appSummaryData.party4_full_name) {
      const n = 4;
      partiesList.push({
        partyNumber: n,
        name: appSummaryData.party4_full_name,
        id: partiesGetPartyID({
          id_nr: appSummaryData.party4_id_nr,
          passport_nr: appSummaryData.party4_passport_nr
        }),
        status: appSummaryData.party4_party_status ?? '',
        notes: appSummaryData.party4_party_notes ?? '',
        user_uuid: appSummaryData.party4_user_uuid ?? null,
        showStatusNotesUpdate: Object.prototype.hasOwnProperty.call(appSummaryData, `party${n}_party_status`) && Object.prototype.hasOwnProperty.call(appSummaryData, `party${n}_party_notes`)
      });
    }
    if (appSummaryData.party5_full_name) {
      const n = 5;
      partiesList.push({
        partyNumber: n,
        name: appSummaryData.party5_full_name,
        id: partiesGetPartyID({
          id_nr: appSummaryData.party5_id_nr,
          passport_nr: appSummaryData.party5_passport_nr
        }),
        status: appSummaryData.party5_party_status ?? '',
        notes: appSummaryData.party5_party_notes ?? '',
        user_uuid: appSummaryData.party5_user_uuid ?? null,
        showStatusNotesUpdate: Object.prototype.hasOwnProperty.call(appSummaryData, `party${n}_party_status`) && Object.prototype.hasOwnProperty.call(appSummaryData, `party${n}_party_notes`)
      });
    }
    
    // Create rows for each party
    if (partiesList.length > 0) {
      partiesList.forEach((party) => {
        const row = partiesTbody.insertRow();
        row.style.margin = '0';
        row.style.padding = '0';
        row.style.lineHeight = '1.2'; // Reduce line height
        
        const nameCell = row.insertCell(0);
        nameCell.style.verticalAlign = 'top';
        nameCell.style.paddingTop = '0';
        nameCell.style.paddingBottom = '0';
        nameCell.style.lineHeight = '1.2';
        nameCell.style.display = 'table-cell';
        nameCell.innerHTML = party.name || '';
        
        const idCell = row.insertCell(1);
        idCell.style.verticalAlign = 'top';
        idCell.style.paddingTop = '0';
        idCell.style.paddingBottom = '0';
        idCell.style.lineHeight = '1.2';
        idCell.style.display = 'table-cell';
        idCell.innerHTML = party.id || '';
        
        // Status input field (only if API returned party_status and party_notes for this party)
        const statusCell = row.insertCell(2);
        statusCell.style.verticalAlign = 'top';
        statusCell.style.paddingTop = '0';
        statusCell.style.paddingBottom = '0';
        statusCell.style.display = 'table-cell';
        if (party.showStatusNotesUpdate) {
          const statusInputContainer = document.createElement('div');
          statusInputContainer.style.position = 'relative';
          statusInputContainer.style.display = 'flex';
          statusInputContainer.style.alignItems = 'flex-start';
          const statusInput = document.createElement('input');
          statusInput.type = 'text';
          statusInput.id = `party${party.partyNumber}_status`;
          statusInput.className = 'w-full';
          statusInput.style.padding = '4px';
          statusInput.style.border = '1px solid #ccc';
          statusInput.style.borderRadius = '4px';
          statusInput.style.color = '#000';
          statusInput.style.backgroundColor = '#fff';
          statusInput.style.height = '32px'; // Match textarea height
          statusInput.style.boxSizing = 'border-box';
          // Error message element
          const statusErrorMsg = document.createElement('span');
          statusErrorMsg.id = `party${party.partyNumber}_status_error`;
          statusErrorMsg.style.display = 'none';
          statusErrorMsg.style.color = '#DC0303';
          statusErrorMsg.style.fontSize = '12px';
          statusErrorMsg.style.position = 'absolute';
          statusErrorMsg.style.left = '0';
          statusErrorMsg.style.bottom = '-18px';
          statusErrorMsg.style.whiteSpace = 'nowrap';
          // Set value before appending
          const statusValue = party.status ?? '';
          statusInput.value = statusValue;
          statusInput.setAttribute('value', statusValue);
          statusInputContainer.appendChild(statusInput);
          statusInputContainer.appendChild(statusErrorMsg);
          statusCell.appendChild(statusInputContainer);
          // Set again after appending to ensure it persists
          setTimeout(() => {
            statusInput.value = statusValue;
          }, 0);
        }
        
        // Notes textarea (only if API returned party_status and party_notes for this party)
        const notesCell = row.insertCell(3);
        notesCell.style.verticalAlign = 'top';
        notesCell.style.paddingTop = '0';
        notesCell.style.paddingBottom = '0';
        notesCell.style.display = 'table-cell';
        if (party.showStatusNotesUpdate) {
          const notesTextarea = document.createElement('textarea');
          const notesValue = party.notes ?? '';
          notesTextarea.id = `party${party.partyNumber}_notes`;
          notesTextarea.className = 'w-full';
          notesTextarea.style.padding = '4px';
          notesTextarea.style.border = '1px solid #ccc';
          notesTextarea.style.borderRadius = '4px';
          notesTextarea.style.minHeight = '40px';
          notesTextarea.style.height = '40px'; // Set fixed height to match input
          notesTextarea.style.marginTop = '0';
          notesTextarea.style.marginBottom = '0';
          notesTextarea.style.resize = 'vertical';
          notesTextarea.style.color = '#000';
          notesTextarea.style.backgroundColor = '#fff';
          notesTextarea.style.boxSizing = 'border-box';
          notesTextarea.style.verticalAlign = 'top';
          // Set value before appending
          notesTextarea.value = notesValue;
          notesTextarea.defaultValue = notesValue;
          notesCell.appendChild(notesTextarea);
          // Set again after appending to ensure it persists
          setTimeout(() => {
            notesTextarea.value = notesValue;
            notesTextarea.defaultValue = notesValue;
            notesTextarea.dispatchEvent(new Event('input', { bubbles: true }));
          }, 0);
          setTimeout(() => {
            if (notesTextarea.value !== notesValue) {
              notesTextarea.value = notesValue;
              notesTextarea.defaultValue = notesValue;
            }
          }, 100);
        }
        
        // Update button (only if API returned party_status and party_notes for this party)
        const updateCell = row.insertCell(4);
        updateCell.style.verticalAlign = 'top';
        updateCell.style.paddingTop = '0';
        updateCell.style.paddingBottom = '0';
        updateCell.style.display = 'table-cell';
        if (party.showStatusNotesUpdate) {
          const updateButton = document.createElement('button');
          updateButton.style.marginTop = '0';
          updateButton.style.marginBottom = '0';
          updateButton.style.height = '32px'; // Match input/textarea height
          updateButton.style.boxSizing = 'border-box';
          updateButton.textContent = 'Update';
          updateButton.className = 'btn';
          if (party.user_uuid) {
            updateButton.setAttribute('onclick', `thsTab.updatePartyDetails('${party.user_uuid}', ${party.partyNumber}, document.getElementById('party${party.partyNumber}_status').value, document.getElementById('party${party.partyNumber}_notes').value)`);
          } else {
            updateButton.disabled = true;
            updateButton.title = 'Party user UUID not available';
          }
          updateCell.appendChild(updateButton);
        }
        
        // Delete icon (only if showDeleteIcon is true - requires change_parties_yn AND 2+ parties)
        if (partiesShowDeleteIcon) {
          const deleteCell = row.insertCell(5);
          deleteCell.style.verticalAlign = 'top';
          deleteCell.style.paddingTop = '0';
          deleteCell.style.paddingBottom = '0';
          deleteCell.style.display = 'table-cell';
          deleteCell.style.textAlign = 'center';
          const deleteOnclick = `thsTab.removeParty('${party.user_uuid}', '${party.name.replace(/'/g, "\\'")}', ${party.partyNumber})`;
          const deleteSVG = svg.trash(deleteOnclick);
          deleteCell.appendChild(deleteSVG);
        }
      });
    } else {
      // Show empty state if no parties
      const row = partiesTbody.insertRow();
      const emptyCell = row.insertCell(0);
      emptyCell.innerHTML = 'No parties available.';
      emptyCell.colSpan = partiesColumnCount;
    }
    
    partiesTable.appendChild(partiesTbody);
    parties_row.appendChild(partiesTable);
    
    // Add icon below the parties table (only if change_parties_yn is true)
    if (partiesChangePartiesYN) {
      const partyIconContainer = document.createElement('div');
      partyIconContainer.style.display = 'flex';
      partyIconContainer.style.alignItems = 'center';
      partyIconContainer.style.gap = '0.5rem';
      partyIconContainer.style.marginTop = '0.25rem'; // Minimal spacing
      
      const addPartyIcon = svg.users();
      addPartyIcon.style.cursor = 'pointer';
      addPartyIcon.style.width = '24px';
      addPartyIcon.style.height = '24px';
      addPartyIcon.style.color = '#6c9ae4'; // Primary color
      addPartyIcon.setAttribute('title', 'Add new party');
      addPartyIcon.setAttribute('onclick', 'thsTab.toggleAddPartyForm()');
      
      const partyIconLabel = document.createElement('span');
      partyIconLabel.textContent = 'Add new party';
      partyIconLabel.style.cursor = 'pointer';
      partyIconLabel.style.color = '#6c9ae4';
      partyIconLabel.setAttribute('onclick', 'thsTab.toggleAddPartyForm()');
      
      partyIconContainer.appendChild(addPartyIcon);
      partyIconContainer.appendChild(partyIconLabel);
      parties_row.appendChild(partyIconContainer);
      
      // Create container for the add party form right below the icon
      const addPartyFormContainer = document.createElement('div');
      addPartyFormContainer.id = 'addPartyFormContainer';
      addPartyFormContainer.style.display = 'none'; // Hidden by default
      addPartyFormContainer.className = 'mt-4';
      parties_row.appendChild(addPartyFormContainer);
    }

    // NOTES -------
    // Only show notes section if application_notes_yn is true
    const notes_row = U.id('notes_row');
    const notesHeading = U.id('notes_heading');
    
    // Check if application_notes_yn is true (handle both boolean true and string "true")
    const showNotes = appSummaryData.application_notes_yn === true || appSummaryData.application_notes_yn === 'true';
    
    if (showNotes) {
      // Show the heading and section
      if (notesHeading) {
        notesHeading.style.display = '';
      }
      
      notes_row.innerHTML = ''; // Clear any existing content
      notes_row.style.display = ''; // Show the notes section
      notes_row.className = ''; // Remove res-grid-cols-4 constraint
      notes_row.style.overflowX = 'auto'; // Allow horizontal scrolling if needed
      notes_row.style.width = '100%'; // Ensure container takes full width
      
      // Create table for Notes
      const notesTable = U.divAtt('table');
      notesTable.style.width = '1200px';
      notesTable.style.tableLayout = 'fixed'; // Use fixed layout for consistent column widths
      notesTable.style.outline = 'none'; // Remove default outline
      notesTable.style.border = 'none'; // Remove all borders
      
      // HEADER
      const notesThead = U.divAtt('thead');
      notesThead.style.backgroundColor = 'transparent'; // Remove blue background
      notesThead.style.color = '#000'; // Set text color to black
      const notesHeadRow = notesThead.insertRow();
      
      const datetimeHeader = notesHeadRow.insertCell(0);
      datetimeHeader.innerHTML = 'Datetime';
      datetimeHeader.style.width = '200px';
      datetimeHeader.style.verticalAlign = 'top';
      datetimeHeader.style.fontSize = '0.875rem'; // text-sm
      datetimeHeader.style.fontWeight = '300'; // font-light
      datetimeHeader.style.letterSpacing = '0.025em'; // tracking-wide
      datetimeHeader.style.color = '#374151'; // grey-dark
      
      const addedByHeader = notesHeadRow.insertCell(1);
      addedByHeader.innerHTML = 'Added by';
      addedByHeader.style.width = '200px';
      addedByHeader.style.verticalAlign = 'top';
      addedByHeader.style.fontSize = '0.875rem';
      addedByHeader.style.fontWeight = '300';
      addedByHeader.style.letterSpacing = '0.025em';
      addedByHeader.style.color = '#374151';
      
      const noteHeader = notesHeadRow.insertCell(2);
      noteHeader.innerHTML = 'Note';
      noteHeader.style.width = '800px';
      noteHeader.style.verticalAlign = 'top';
      noteHeader.style.fontSize = '0.875rem';
      noteHeader.style.fontWeight = '300';
      noteHeader.style.letterSpacing = '0.025em';
      noteHeader.style.color = '#374151';
      
      notesThead.appendChild(notesHeadRow);
      notesTable.appendChild(notesThead);
      
      // BODY
      const notesTbody = U.divAtt('tbody');
      
      // Get notes from appSummaryData
      const notes = appSummaryData.notes || [];
      
      if (notes.length > 0) {
        for (const note of notes) {
          const row = notesTbody.insertRow();
          
          const datetimeCell = row.insertCell(0);
          datetimeCell.style.verticalAlign = 'top';
          datetimeCell.innerHTML = note.created_date ? await U.formatDateTime(note.created_date) : '';
          
          const addedByCell = row.insertCell(1);
          addedByCell.style.verticalAlign = 'top';
          const addedByName = `${note.f_name || ''} ${note.s_name || ''}`.trim();
          addedByCell.innerHTML = addedByName || '';
          
          const noteCell = row.insertCell(2);
          noteCell.style.verticalAlign = 'top';
          noteCell.style.wordWrap = 'break-word';
          noteCell.style.overflowWrap = 'break-word';
          noteCell.innerHTML = note.note_details || '';
        }
      } else {
        // Show empty state if no notes
        const row = notesTbody.insertRow();
        const emptyCell = row.insertCell(0);
        emptyCell.innerHTML = 'No notes available.';
        emptyCell.colSpan = 3;
      }
      
      notesTable.appendChild(notesTbody);
      notes_row.appendChild(notesTable);
      
      // Add plus icon below the notes table
      const iconContainer = document.createElement('div');
      iconContainer.className = 'mt-4';
      iconContainer.style.display = 'flex';
      iconContainer.style.alignItems = 'center';
      iconContainer.style.gap = '0.5rem';
      
      const addNoteIcon = svg.pencilSquare();
      addNoteIcon.style.cursor = 'pointer';
      addNoteIcon.style.width = '24px';
      addNoteIcon.style.height = '24px';
      addNoteIcon.style.color = '#6c9ae4'; // Primary color
      addNoteIcon.setAttribute('title', 'Add new note');
      addNoteIcon.setAttribute('onclick', 'thsTab.toggleAddNoteForm()');
      
      const iconLabel = document.createElement('span');
      iconLabel.textContent = 'Add new note';
      iconLabel.style.cursor = 'pointer';
      iconLabel.style.color = '#6c9ae4';
      iconLabel.setAttribute('onclick', 'thsTab.toggleAddNoteForm()');
      
      iconContainer.appendChild(addNoteIcon);
      iconContainer.appendChild(iconLabel);
      notes_row.appendChild(iconContainer);

      // ADD NEW NOTE SECTION -------
      const addNoteSection = U.id('addNoteSection');
      if (addNoteSection) {
        addNoteSection.innerHTML = ''; // Clear any existing content
        addNoteSection.className = 'mt-4';
        addNoteSection.style.width = '100%';
        addNoteSection.style.display = 'none'; // Hide by default
        
        // Create textarea container
        const textareaContainer = document.createElement('div');
        textareaContainer.className = 'mb-4';
        
        const textareaLabel = document.createElement('label');
        textareaLabel.className = 'block text-left mb-2';
        textareaLabel.textContent = 'Add new note';
        textareaLabel.setAttribute('for', 'newNoteTextarea');
        
        const textarea = document.createElement('textarea');
        textarea.id = 'newNoteTextarea';
        textarea.className = 'w-full p-2 border rounded';
        textarea.style.minHeight = '80px';
        textarea.style.resize = 'vertical';
        textarea.placeholder = 'Enter your note here...';
        
        textareaContainer.appendChild(textareaLabel);
        textareaContainer.appendChild(textarea);
        addNoteSection.appendChild(textareaContainer);
        
        // Create button
        const addNoteButton = document.createElement('button');
        addNoteButton.textContent = 'Add new note';
        addNoteButton.className = 'btn';
        addNoteButton.setAttribute('onclick', 'thsTab.addNewNote()');
        addNoteSection.appendChild(addNoteButton);
      }
    } else {
      // Hide the notes section and heading if application_notes_yn is false
      if (notesHeading) {
        notesHeading.style.display = 'none';
      }
      notes_row.innerHTML = ''; // Clear any existing content
      notes_row.style.display = 'none'; // Hide the notes section
      const addNoteSection = U.id('addNoteSection');
      if (addNoteSection) {
        addNoteSection.innerHTML = '';
        addNoteSection.style.display = 'none';
      }
      const notesActions = U.id('notes_actions');
      if (notesActions) {
        notesActions.innerHTML = '';
        notesActions.style.display = 'none';
      }
    }

    // DISCOUNT ARRANGEMENT -------
    const discount_row = U.id('discount_row');
    const discountHeading = U.id('discount_heading');
    discount_row.innerHTML = ''; // Clear any existing content
    
    // Check if final_discount_yn and final_discount_description exist in the response
    const hasDiscountFields = appSummaryData.hasOwnProperty('final_discount_yn') && 
                              appSummaryData.hasOwnProperty('final_discount_description');
    
    if (hasDiscountFields) {
      discount_row.style.display = ''; // Show the discount section
      if (discountHeading) {
        discountHeading.style.display = '';
      }
      
      const finalDiscountYN = appSummaryData.final_discount_yn;
      const finalDiscountDescription = appSummaryData.final_discount_description;
      
      // If both are null, show editable form
      if (finalDiscountYN === null && finalDiscountDescription === null) {
        // Create checkbox
        const checkboxDiv = await comp.inputCheckbox('finalDiscountYN', false, 'Discount arranged', 'thsTab.toggleDiscountTextarea()');
        discount_row.appendChild(checkboxDiv);
        
        // Create container for textarea and button (initially hidden)
        const formContainer = document.createElement('div');
        formContainer.id = 'discountFormContainer';
        formContainer.style.display = 'none'; // Hidden by default
        formContainer.style.marginTop = '1rem';
        
        // Create textarea
        const textareaDiv = await comp.textarea('finalDiscountDescription', '', 'Discount arrangement', 0);
        const textarea = textareaDiv.querySelector('#finalDiscountDescription');
        if (textarea) {
          // Textarea is enabled when visible (checkbox is checked)
          textarea.disabled = false;
        }
        formContainer.appendChild(textareaDiv);
        
        // Create button
        const button = document.createElement('button');
        button.textContent = 'Record discount arrangement';
        button.className = 'btn';
        button.setAttribute('onclick', 'thsTab.recordDiscountArrangement()');
        button.style.marginTop = '1rem';
        formContainer.appendChild(button);
        
        discount_row.appendChild(formContainer);
      } else {
        // Show display-only: checkbox checked and text displayed
        const container = document.createElement('div');
        container.className = 'space-y-4';
        
        // Display checkbox as checked (read-only)
        const checkboxDisplay = await comp.inputCheckbox('finalDiscountYN_display', true, 'Discount arranged', null);
        const checkboxInput = checkboxDisplay.querySelector('#finalDiscountYN_display');
        if (checkboxInput) {
          checkboxInput.disabled = true;
          checkboxInput.checked = true;
        }
        container.appendChild(checkboxDisplay);
        
        // Display text as plain text (not textarea-like)
        const textDisplay = document.createElement('div');
        const label = document.createElement('label');
        label.textContent = 'Discount arrangement';
        label.className = 'block text-left mb-2 font-medium';
        textDisplay.appendChild(label);
        
        const textDiv = document.createElement('div');
        textDiv.className = 'text-left';
        textDiv.style.whiteSpace = 'pre-wrap';
        textDiv.style.wordWrap = 'break-word';
        textDiv.style.lineHeight = '1.5';
        textDiv.textContent = finalDiscountDescription || '';
        textDisplay.appendChild(textDiv);
        
        container.appendChild(textDisplay);
        discount_row.appendChild(container);
      }
    } else {
      // Hide the discount section if fields don't exist
      if (discountHeading) {
        discountHeading.style.display = 'none';
      }
      discount_row.style.display = 'none';
    }

    // ADDITIONAL PRODUCTS -------
    const additionalProductsSection = U.id('additionalProducts_section');
    const additionalProductsHeading = U.id('additionalProducts_heading');
    
    // Check if manage_other_products_yn is true
    const manageOtherProductsYN = appSummaryData.manage_other_products_yn === true || appSummaryData.manage_other_products_yn === 'true';
    
    // Show section if manage_other_products_yn is true and underwriters data is available
    if (manageOtherProductsYN && this.underwriters && Array.isArray(this.underwriters) && this.underwriters.length > 0) {
      // Get or create the section container
      let sectionContainer = additionalProductsSection;
      if (!sectionContainer) {
        sectionContainer = document.createElement('div');
        sectionContainer.id = 'additionalProducts_section';
        // Insert after discount_row
        const discountRow = U.id('discount_row');
        if (discountRow && discountRow.parentNode) {
          discountRow.parentNode.insertBefore(sectionContainer, discountRow.nextSibling);
        } else {
          // Fallback: append to card if discount_row not found
          const card = document.querySelector('.card');
          if (card) {
            card.appendChild(sectionContainer);
          }
        }
      }
      
      sectionContainer.innerHTML = ''; // Clear any existing content
      sectionContainer.style.display = ''; // Show the section
      
      // Always create and add the main heading (since we cleared innerHTML above)
      const heading = document.createElement('h6');
      heading.className = 'text-primary mt-8';
      heading.id = 'additionalProducts_heading';
      heading.textContent = 'Additional products';
      sectionContainer.appendChild(heading);
      
      // Create Estate Plan sub-section
      const estatePlanContainer = document.createElement('div');
      estatePlanContainer.className = 'mt-4';
      
      // Get other_products array
      const otherProducts = appSummaryData.other_products || [];
      
      // If there are existing products, display them in a table (replacing "Estate plan" label)
      if (otherProducts.length > 0) {
        // Create table container
        const productsTableContainer = document.createElement('div');
        productsTableContainer.style.overflowX = 'auto';
        productsTableContainer.style.width = '100%';
        
        // Create table for Other Products - match Notes table styling
        const productsTable = U.divAtt('table');
        productsTable.style.width = '1200px';
        productsTable.style.tableLayout = 'fixed';
        productsTable.style.outline = 'none';
        productsTable.style.border = 'none';
        
        // HEADER
        const productsThead = U.divAtt('thead');
        productsThead.style.backgroundColor = 'transparent';
        productsThead.style.color = '#000';
        const productsHeadRow = productsThead.insertRow();
        
        // Column widths: Date (150px), Captured by (150px), Product (120px), Underwriter (150px), Policy (120px), Description (260px), Documents (150px)
        const headers = [
          { text: 'Date added', width: 150 },
          { text: 'Captured by', width: 150 },
          { text: 'Product', width: 120 },
          { text: 'Underwriter', width: 150 },
          { text: 'Policy number', width: 120 },
          { text: 'Description', width: 260 },
          { text: 'Documents', width: 150 }
        ];
        
        headers.forEach(header => {
          const th = productsHeadRow.insertCell();
          th.innerHTML = header.text;
          th.style.width = `${header.width}px`;
          th.style.verticalAlign = 'top';
          th.style.fontSize = '0.875rem';
          th.style.fontWeight = '300';
          th.style.letterSpacing = '0.025em';
          th.style.color = '#374151';
        });
        
        productsThead.appendChild(productsHeadRow);
        productsTable.appendChild(productsThead);
        
        // BODY
        const productsTbody = U.divAtt('tbody');
        
        for (const product of otherProducts) {
          const row = productsTbody.insertRow();
          
          // Date added
          const dateCell = row.insertCell(0);
          dateCell.style.verticalAlign = 'top';
          dateCell.innerHTML = product.date_added ? await U.formatDateTime(product.date_added) : '';
          
          // Captured by
          const capturedByCell = row.insertCell(1);
          capturedByCell.style.verticalAlign = 'top';
          capturedByCell.innerHTML = product.captured_by || '';
          
          // Product name
          const productCell = row.insertCell(2);
          productCell.style.verticalAlign = 'top';
          productCell.innerHTML = product.product_name || '';
          
          // Underwriter
          const underwriterCell = row.insertCell(3);
          underwriterCell.style.verticalAlign = 'top';
          underwriterCell.innerHTML = product.underwriter_name || '';
          
          // Policy number
          const policyCell = row.insertCell(4);
          policyCell.style.verticalAlign = 'top';
          policyCell.innerHTML = product.policy_number || '';
          
          // Description
          const descriptionCell = row.insertCell(5);
          descriptionCell.style.verticalAlign = 'top';
          descriptionCell.style.wordWrap = 'break-word';
          descriptionCell.style.overflowWrap = 'break-word';
          descriptionCell.innerHTML = product.description || '';
          
          // Documents - download icons for document1, document2, document3
          const documentsCell = row.insertCell(6);
          documentsCell.style.verticalAlign = 'top';
          documentsCell.style.textAlign = 'center';
          
          const documentsContainer = document.createElement('div');
          documentsContainer.style.display = 'flex';
          documentsContainer.style.gap = '0.5rem';
          documentsContainer.style.justifyContent = 'center';
          documentsContainer.style.alignItems = 'center';
          
          // Add download icons for each non-null document
          if (product.document1) {
            const downloadOnclick1 = `thsTab.downloadFile('${product.document1}')`;
            const downloadIcon1 = svg.download(downloadOnclick1);
            downloadIcon1.style.cursor = 'pointer';
            downloadIcon1.style.width = '20px';
            downloadIcon1.style.height = '20px';
            documentsContainer.appendChild(downloadIcon1);
          }
          if (product.document2) {
            const downloadOnclick2 = `thsTab.downloadFile('${product.document2}')`;
            const downloadIcon2 = svg.download(downloadOnclick2);
            downloadIcon2.style.cursor = 'pointer';
            downloadIcon2.style.width = '20px';
            downloadIcon2.style.height = '20px';
            documentsContainer.appendChild(downloadIcon2);
          }
          if (product.document3) {
            const downloadOnclick3 = `thsTab.downloadFile('${product.document3}')`;
            const downloadIcon3 = svg.download(downloadOnclick3);
            downloadIcon3.style.cursor = 'pointer';
            downloadIcon3.style.width = '20px';
            downloadIcon3.style.height = '20px';
            documentsContainer.appendChild(downloadIcon3);
          }
          
          documentsCell.appendChild(documentsContainer);
        }
        
        productsTable.appendChild(productsTbody);
        productsTableContainer.appendChild(productsTable);
        estatePlanContainer.appendChild(productsTableContainer);
      } 
      
      // Add icon and title "Add estate plan" underneath the table/list
      const addEstatePlanContainer = document.createElement('div');
      addEstatePlanContainer.style.display = 'flex';
      addEstatePlanContainer.style.alignItems = 'center';
      addEstatePlanContainer.style.gap = '0.5rem';
      addEstatePlanContainer.style.marginTop = '0.5rem';
      addEstatePlanContainer.style.cursor = 'pointer';
      addEstatePlanContainer.setAttribute('onclick', 'thsTab.toggleAddEstatePlanForm()');
      
      const addEstatePlanIcon = svg.pencilSquare();
      addEstatePlanIcon.style.width = '24px';
      addEstatePlanIcon.style.height = '24px';
      addEstatePlanIcon.style.color = '#6c9ae4'; // Primary color
      
      const addEstatePlanLabel = document.createElement('span');
      addEstatePlanLabel.textContent = 'Add estate plan';
      addEstatePlanLabel.style.color = '#6c9ae4';
      addEstatePlanLabel.style.cursor = 'pointer';
      
      addEstatePlanContainer.appendChild(addEstatePlanIcon);
      addEstatePlanContainer.appendChild(addEstatePlanLabel);
      estatePlanContainer.appendChild(addEstatePlanContainer);
      
      // Create container for the add estate plan form (initially hidden)
      const addEstatePlanFormContainer = document.createElement('div');
      addEstatePlanFormContainer.id = 'addEstatePlanFormContainer';
      addEstatePlanFormContainer.style.display = 'none'; // Hidden by default
      addEstatePlanFormContainer.className = 'mt-4';
      estatePlanContainer.appendChild(addEstatePlanFormContainer);
      
      sectionContainer.appendChild(estatePlanContainer);
    } else {
      // Hide the section if manage_other_products_yn is false or underwriters data is not available
      if (additionalProductsSection) {
        additionalProductsSection.style.display = 'none';
      }
      if (additionalProductsHeading) {
        additionalProductsHeading.style.display = 'none';
      }
    }

    // PERSONAL DETAILS ------- (REMOVED - Section no longer displayed)
    /*
    const personalDetails_row = U.id('personalDetails_row');
    personalDetails_row.innerHTML = ''; // Clear any existing content
    personalDetails_row.className = ''; // Remove res-grid-cols-4 constraint
    personalDetails_row.style.overflowX = 'auto'; // Allow horizontal scrolling if needed
    personalDetails_row.style.width = '100%'; // Ensure container takes full width
    
    // Create table for Personal Details - adjust width for 6 columns if change_parties_yn is true
    const changePartiesYN = appSummaryData.change_parties_yn === true;
    // Count how many parties have user_uuid (non-null)
    const partyCount = [
      appSummaryData.party1_user_uuid,
      appSummaryData.party2_user_uuid,
      appSummaryData.party3_user_uuid,
      appSummaryData.party4_user_uuid,
      appSummaryData.party5_user_uuid
    ].filter(uuid => uuid !== null && uuid !== undefined).length;
    // Only show delete icon if change_parties_yn is true AND there are 2 or more parties
    const showDeleteIcon = changePartiesYN && partyCount > 1;
    const columnCount = showDeleteIcon ? 6 : 5;
    const columnWidth = Math.floor(1200 / columnCount);
    const table = U.divAtt('table');
    table.style.width = '1200px';
    table.style.tableLayout = 'fixed'; // Use fixed layout for consistent column widths
    
    // HEADER
    const thead = U.divAtt('thead');
    const headRow = thead.insertRow();
    
    const nameHeader = headRow.insertCell(0);
    nameHeader.innerHTML = 'Name';
    nameHeader.style.width = `${columnWidth}px`;
    nameHeader.style.verticalAlign = 'top';
    const idHeader = headRow.insertCell(1);
    idHeader.innerHTML = 'ID';
    idHeader.style.width = `${columnWidth}px`;
    idHeader.style.verticalAlign = 'top';
    const statusHeader = headRow.insertCell(2);
    statusHeader.innerHTML = 'Status';
    statusHeader.style.width = `${columnWidth}px`;
    statusHeader.style.verticalAlign = 'top';
    const notesHeader = headRow.insertCell(3);
    notesHeader.innerHTML = 'Notes';
    notesHeader.style.width = `${columnWidth}px`;
    notesHeader.style.verticalAlign = 'top';
    const updateHeader = headRow.insertCell(4);
    updateHeader.innerHTML = '';
    updateHeader.style.width = `${columnWidth}px`;
    updateHeader.style.verticalAlign = 'top';
    
    // Add delete column header if showDeleteIcon is true
    if (showDeleteIcon) {
      const deleteHeader = headRow.insertCell(5);
      deleteHeader.innerHTML = '';
      deleteHeader.style.width = `${columnWidth}px`;
      deleteHeader.style.verticalAlign = 'top';
    }
    
    thead.appendChild(headRow);
    table.appendChild(thead);
    
    // BODY
    const tbody = U.divAtt('tbody');
    table.appendChild(tbody);
    
    // Helper function to get party ID (ID number or Passport number)
    const getPartyID = (partyData) => {
      return partyData.id_nr || partyData.passport_nr || '';
    };
    
    // Build array of parties with party number for identification
    const parties = [];
    if (appSummaryData.party1_full_name) {
      parties.push({
        partyNumber: 1,
        name: appSummaryData.party1_full_name,
        id: getPartyID({
          id_nr: appSummaryData.party1_id_nr,
          passport_nr: appSummaryData.party1_passport_nr
        }),
        status: appSummaryData.party1_party_status ?? '',
        notes: appSummaryData.party1_party_notes ?? '',
        user_uuid: appSummaryData.party1_user_uuid ?? null
      });
    }
    if (appSummaryData.party2_full_name) {
      parties.push({
        partyNumber: 2,
        name: appSummaryData.party2_full_name,
        id: getPartyID({
          id_nr: appSummaryData.party2_id_nr,
          passport_nr: appSummaryData.party2_passport_nr
        }),
        status: appSummaryData.party2_party_status ?? '',
        notes: appSummaryData.party2_party_notes ?? '',
        user_uuid: appSummaryData.party2_user_uuid ?? null
      });
    }
    if (appSummaryData.party3_full_name) {
      parties.push({
        partyNumber: 3,
        name: appSummaryData.party3_full_name,
        id: getPartyID({
          id_nr: appSummaryData.party3_id_nr,
          passport_nr: appSummaryData.party3_passport_nr
        }),
        status: appSummaryData.party3_party_status ?? '',
        notes: appSummaryData.party3_party_notes ?? '',
        user_uuid: appSummaryData.party3_user_uuid ?? null
      });
    }
    if (appSummaryData.party4_full_name) {
      parties.push({
        partyNumber: 4,
        name: appSummaryData.party4_full_name,
        id: getPartyID({
          id_nr: appSummaryData.party4_id_nr,
          passport_nr: appSummaryData.party4_passport_nr
        }),
        status: appSummaryData.party4_party_status ?? '',
        notes: appSummaryData.party4_party_notes ?? '',
        user_uuid: appSummaryData.party4_user_uuid ?? null
      });
    }
    if (appSummaryData.party5_full_name) {
      parties.push({
        partyNumber: 5,
        name: appSummaryData.party5_full_name,
        id: getPartyID({
          id_nr: appSummaryData.party5_id_nr,
          passport_nr: appSummaryData.party5_passport_nr
        }),
        status: appSummaryData.party5_party_status ?? '',
        notes: appSummaryData.party5_party_notes ?? '',
        user_uuid: appSummaryData.party5_user_uuid ?? null
      });
    }
    
    // Create rows for each party
    if (parties.length > 0) {
      parties.forEach((party) => {
        const row = tbody.insertRow();
        
        const nameCell = row.insertCell(0);
        nameCell.style.verticalAlign = 'top';
        nameCell.innerHTML = party.name || '';
        
        const idCell = row.insertCell(1);
        idCell.style.verticalAlign = 'top';
        idCell.innerHTML = party.id || '';
        
        // Status input field
        const statusCell = row.insertCell(2);
        statusCell.style.verticalAlign = 'top';
        const statusInputContainer = document.createElement('div');
        statusInputContainer.style.position = 'relative';
        const statusInput = document.createElement('input');
        statusInput.type = 'text';
        statusInput.id = `party${party.partyNumber}_status`;
        statusInput.className = 'w-full';
        statusInput.style.padding = '4px';
        statusInput.style.border = '1px solid #ccc';
        statusInput.style.borderRadius = '4px';
        statusInput.style.color = '#000'; // Ensure text color is visible
        statusInput.style.backgroundColor = '#fff'; // Ensure background is white
        // Error message element
        const statusErrorMsg = document.createElement('span');
        statusErrorMsg.id = `party${party.partyNumber}_status_error`;
        statusErrorMsg.style.display = 'none';
        statusErrorMsg.style.color = '#DC0303'; // Error color
        statusErrorMsg.style.fontSize = '12px';
        statusErrorMsg.style.position = 'absolute';
        statusErrorMsg.style.left = '0';
        statusErrorMsg.style.bottom = '-18px';
        statusErrorMsg.style.whiteSpace = 'nowrap';
        // Set value before appending
        const statusValue = party.status ?? '';
        statusInput.value = statusValue;
        statusInput.setAttribute('value', statusValue); // Also set as attribute
        statusInputContainer.appendChild(statusInput);
        statusInputContainer.appendChild(statusErrorMsg);
        statusCell.appendChild(statusInputContainer);
        // Set again after appending to ensure it persists
        setTimeout(() => {
          statusInput.value = statusValue;
        }, 0);
        
        // Notes textarea
        const notesCell = row.insertCell(3);
        notesCell.style.verticalAlign = 'top';
        const notesTextarea = document.createElement('textarea');
        const notesValue = party.notes ?? '';
        notesTextarea.id = `party${party.partyNumber}_notes`;
        notesTextarea.className = 'w-full';
        notesTextarea.style.padding = '4px';
        notesTextarea.style.border = '1px solid #ccc';
        notesTextarea.style.borderRadius = '4px';
        notesTextarea.style.minHeight = '60px';
        notesTextarea.style.resize = 'vertical';
        notesTextarea.style.color = '#000'; // Ensure text color is visible
        notesTextarea.style.backgroundColor = '#fff'; // Ensure background is white
        // Set value before appending
        notesTextarea.value = notesValue;
        notesTextarea.defaultValue = notesValue; // Also set defaultValue
        notesCell.appendChild(notesTextarea);
        // Set again after appending to ensure it persists
        setTimeout(() => {
          notesTextarea.value = notesValue;
          notesTextarea.defaultValue = notesValue;
          // Force a re-render by triggering input event
          notesTextarea.dispatchEvent(new Event('input', { bubbles: true }));
        }, 0);
        // Also set after a longer delay to catch any late-clearing issues
        setTimeout(() => {
          if (notesTextarea.value !== notesValue) {
            notesTextarea.value = notesValue;
            notesTextarea.defaultValue = notesValue;
          }
        }, 100);
        
        // Update button
        const updateCell = row.insertCell(4);
        updateCell.style.verticalAlign = 'top';
        const updateButton = document.createElement('button');
        updateButton.textContent = 'Update';
        updateButton.className = 'btn';
        if (party.user_uuid) {
          updateButton.setAttribute('onclick', `thsTab.updatePartyDetails('${party.user_uuid}', ${party.partyNumber}, document.getElementById('party${party.partyNumber}_status').value, document.getElementById('party${party.partyNumber}_notes').value)`);
        } else {
          updateButton.disabled = true;
          updateButton.title = 'Party user UUID not available';
        }
        updateCell.appendChild(updateButton);
        
        // Delete icon (only if showDeleteIcon is true - requires change_parties_yn AND 2+ parties)
        if (showDeleteIcon) {
          const deleteCell = row.insertCell(5);
          deleteCell.style.verticalAlign = 'top';
          deleteCell.style.textAlign = 'center';
          const deleteOnclick = `thsTab.removeParty('${party.user_uuid}', '${party.name.replace(/'/g, "\\'")}', ${party.partyNumber})`;
          const deleteSVG = svg.trash(deleteOnclick);
          deleteCell.appendChild(deleteSVG);
        }
      });
    } else {
      // Show empty state if no parties
      const row = tbody.insertRow();
      const emptyCell = row.insertCell(0);
      emptyCell.innerHTML = 'No parties available.';
      emptyCell.colSpan = columnCount; // Use dynamic column count
    }
    
    personalDetails_row.appendChild(table);
    */

    // ADD NEW PARTY SECTION -------
    // Only show add party section if change_parties_yn is true
    // But keep it hidden by default - will be shown when icon is clicked
      const addPartySection = U.id('addPartySection');
      if (addPartySection) {
        addPartySection.innerHTML = '';
      addPartySection.style.display = 'none'; // Hide by default
    }

    // AMENDED REFERENCE -------
    if (appSummaryData.original_application) {
      // Get or create the section container
      let amendedSection = U.id('amendedReference_section');
      if (!amendedSection) {
        amendedSection = document.createElement('div');
        amendedSection.id = 'amendedReference_section';
        // Insert after discount_row
        const discountRow = U.id('discount_row');
        if (discountRow && discountRow.parentNode) {
          discountRow.parentNode.insertBefore(amendedSection, discountRow.nextSibling);
        } else {
          // Fallback: append to card if discount_row not found
          const card = document.querySelector('.card');
          if (card) {
            card.appendChild(amendedSection);
          }
        }
      }
      
      // Create and add the header
      const header = document.createElement('h6');
      header.className = 'text-primary';
      header.textContent = 'Amended reference';
      amendedSection.appendChild(header);
      
      // Create and add the row
      const amendedReference_row = document.createElement('div');
      amendedReference_row.id = 'amendedReference_row';
      amendedReference_row.className = 'res-grid-cols-4';
      amendedSection.appendChild(amendedReference_row);
      
      const originalApp = appSummaryData.original_application;
      
      // Display application ID with link icon
      const appIdContainer = U.divAtt('div', 'class', 'flex items-center gap-2');
      const appIdText = comp.displayText('originalAppId', `Application ID: ${originalApp.h_application_id}`, 'Application ID');
      appIdContainer.appendChild(appIdText);
      
      // Add link icon
      if (appSummaryData.amended_uuid) {
        const editAppLink = `O.PREP('ViewApplication', 'application_uuid=${appSummaryData.amended_uuid}')`;
        const linkSVG = svg.linkNewPage(editAppLink);
        appIdContainer.appendChild(linkSVG);
      }
      amendedReference_row.appendChild(appIdContainer);
      
      // Display created date
      const createdDateText = comp.displayText('originalCreatedDate', await U.formatDate(originalApp.created_date), 'Created Date');
      amendedReference_row.appendChild(createdDateText);
      
      // Display status
      const statusTag = await comp.statusTag(originalApp.status);
      const statusContainer = U.divAtt('div');
      statusContainer.appendChild(statusTag);
      amendedReference_row.appendChild(statusContainer);
      
      // Display parties
      const partiesText = comp.displayText('originalParties', 
        [originalApp.party1, originalApp.party2, originalApp.party3, originalApp.party4, originalApp.party5]
          .filter(p => p)
          .join(', '), 
        'Parties');
      amendedReference_row.appendChild(partiesText);
    } else {
      // Hide the section if it exists but original_application is not present
      const amendedSection = U.id('amendedReference_section');
      if (amendedSection) {
        amendedSection.style.display = 'none';
      }
    }
  },
  
  async updatePartyDetails(party_user_uuid, partyNumber, status, notes) {
    // Get the status input and error message elements
    const statusInput = document.getElementById(`party${partyNumber}_status`);
    const statusErrorMsg = document.getElementById(`party${partyNumber}_status_error`);
    
    // Validate status has at least 5 characters
    if (!status || status.trim().length < 5) {
      // Highlight the status input field with red border
      if (statusInput) {
        statusInput.classList.add('input-error');
        statusInput.style.border = '2px solid #DC0303';
        statusInput.style.outline = '2px solid #DC0303';
        // Show error message below the input
        if (statusErrorMsg) {
          statusErrorMsg.textContent = 'Update with a relevant status';
          statusErrorMsg.style.display = 'block';
        }
        // Scroll to the input field to make it visible
        statusInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // Focus the input so user can immediately type
        setTimeout(() => {
          statusInput.focus();
        }, 300);
        // Also show toast for additional visibility
        comp.toast('Update with a relevant status');
      } else {
        comp.toast('Update with a relevant status');
      }
      return;
    }
    
    // Clear any previous error styling if validation passes
    if (statusInput) {
      statusInput.classList.remove('input-error');
      statusInput.style.border = '1px solid #ccc';
      statusInput.style.outline = '';
    }
    if (statusErrorMsg) {
      statusErrorMsg.style.display = 'none';
    }
    
    const vars = {};
    vars.party_user_uuid = party_user_uuid;
    vars.party_status = status.trim();
    vars.party_notes = notes || '';
    
    try {
      const response = await O.PREP([await O.mPOST('application/ups-party-status', vars)]);
      const result = response['application/ups-party-status'];
      
      if (result.status === 'OK') {
        comp.toast('Party details updated successfully');
        // Reload the page to refresh data
        await this.render();
      } else {
        comp.errorBox('Error', result.message || 'Failed to update party details');
      }
    } catch (error) {
      comp.errorBox('Error', 'Failed to update party details. Please try again.');
    }
  },

  async setupOverviewChangeAdvisorBar() {
    const bar = U.id('overviewChangeAdvisorBar');
    if (!bar) return;

    const isAdmin = this.loggedInRoleText === 'Admin';
    if (!isAdmin) {
      bar.classList.add('hide');
      bar.classList.remove('flex');
      return;
    }

    bar.classList.remove('hide');
    bar.classList.add('flex');

    const container = U.id('overviewTargetAdvisorLookupContainer');
    if (!container) return;

    if (!container.querySelector('#overviewTargetAdvisorDD')) {
      const inputEl = await comp.inputText('overviewTargetAdvisorDD', '', '', 0, '', 'Search advisor...', true);
      container.appendChild(inputEl);

      const input = U.id('overviewTargetAdvisorDD');
      if (input) {
        input.addEventListener('input', () => {
          if (input.value === '') {
            thsPage.vars.overview_target_advisor = '';
            thsPage.vars.overview_target_advisor_text = '';
            thsTab.clearOverviewChangeAdvisorFile();
            thsTab.updateOverviewChangeAdvisorButtonVisibility();
          }
          clearTimeout(thsTab.overviewAdvisorTimeout);
          const query = input.value.trim();
          if (query.length < 3) {
            const dropdown = U.id('overviewTargetAdvisorListDropdownContainer');
            if (dropdown) dropdown.remove();
            return;
          }
          thsTab.overviewAdvisorTimeout = setTimeout(() => {
            thsTab.getSuggestedOverviewTargetAdvisors();
          }, 1000);
        });
      }

      document.addEventListener('mousedown', (e) => {
        const dropdownEl = U.id('overviewTargetAdvisorListDropdownContainer');
        if (
          dropdownEl &&
          e.target !== dropdownEl &&
          e.target.parentNode?.id !== 'overviewTargetAdvisorListDropdown'
        ) {
          dropdownEl.remove();
        }
      });
    }

    this.setupOverviewChangeAdvisorFileInput();

    thsPage.vars.overview_target_advisor = '';
    thsPage.vars.overview_target_advisor_text = '';
    const existingInput = U.id('overviewTargetAdvisorDD');
    if (existingInput) existingInput.value = '';
    this.clearOverviewChangeAdvisorFile();
    this.updateOverviewChangeAdvisorButtonVisibility();
  },

  setupOverviewChangeAdvisorFileInput() {
    const fileInput = U.id('overviewChangeAdvisorFile');
    if (!fileInput || fileInput.dataset.bound === '1') return;
    fileInput.dataset.bound = '1';
    fileInput.addEventListener('change', () => {
      fileInput.classList.remove('input-error');
      thsTab.updateOverviewChangeAdvisorButtonVisibility();
    });
  },

  clearOverviewChangeAdvisorFile() {
    const fileInput = U.id('overviewChangeAdvisorFile');
    if (fileInput) {
      fileInput.value = '';
      fileInput.classList.remove('input-error');
    }
    const fileContainer = U.id('overviewChangeAdvisorFileContainer');
    if (fileContainer) {
      fileContainer.classList.add('hide');
      fileContainer.classList.remove('flex');
    }
  },

  updateOverviewChangeAdvisorButtonVisibility() {
    const btn = U.id('overviewChangeAdvisorBtn');
    const fileContainer = U.id('overviewChangeAdvisorFileContainer');
    if (!btn) return;

    const hasTarget = !!thsPage.vars.overview_target_advisor;
    const fileInput = U.id('overviewChangeAdvisorFile');
    const hasFile = !!(fileInput && fileInput.files && fileInput.files.length > 0);

    // File selector only when Change advisor button is shown
    if (fileContainer) {
      fileContainer.classList.toggle('hide', !hasTarget);
      fileContainer.classList.toggle('flex', hasTarget);
    }
    btn.classList.toggle('hide', !hasTarget);
    btn.disabled = !hasTarget || !hasFile;
  },

  async getSuggestedOverviewTargetAdvisors() {
    const input = U.id('overviewTargetAdvisorDD');
    if (!input) return;

    const existingContainer = U.id('overviewTargetAdvisorListDropdownContainer');
    if (existingContainer) existingContainer.remove();

    const query = input.value.trim();
    if (query.length < 3) return;

    try {
      const res = await O.PREP([await O.mPOST('communal/advisor-autosuggest', {search_filter: query})]);
      const advisorListData = res['communal/advisor-autosuggest'].data;
      const advisorListDropdown = await comp.dataListDropdown({
        elID: 'overviewTargetAdvisorListDropdown',
        ddData: advisorListData,
        valueDataName: 'user_uuid',
        textDataName: 'combo_text',
        requiredYN: 0,
        onselect: 'handleOverviewTargetAdvisorSelection',
        className: 'overviewTargetAdvisorSuggestionOption',
      });
      const inputDiv = U.id('overviewTargetAdvisorDDDiv');
      if (inputDiv) inputDiv.appendChild(advisorListDropdown);
    } catch (e) {}
  },

  handleOverviewTargetAdvisorSelection() {
    const dropdown = U.id('overviewTargetAdvisorListDropdownContainer');
    if (dropdown) dropdown.remove();

    if (thsPage.vars.overview_target_advisor_text) {
      const input = U.id('overviewTargetAdvisorDD');
      if (input) input.value = thsPage.vars.overview_target_advisor_text;
    }

    this.updateOverviewChangeAdvisorButtonVisibility();
  },

  async changeOverviewAdvisor() {
    const targetAdvisorUuid = thsPage.vars.overview_target_advisor;
    if (!targetAdvisorUuid || !this.application_uuid) return;

    const fileInput = U.id('overviewChangeAdvisorFile');
    const file = fileInput && fileInput.files && fileInput.files[0];

    if (!file) {
      if (fileInput) fileInput.classList.add('input-error');
      comp.errorBox('Missing file', 'Please choose a file before changing advisor.');
      return;
    }

    const formData = new FormData();
    formData.append('target_advisor_uuid', targetAdvisorUuid);
    formData.append('application_uuid', this.application_uuid);
    formData.append('uploadFile', file);

    const btn = U.id('overviewChangeAdvisorBtn');
    if (btn) btn.disabled = true;

    try {
      const hdrs = await O.getAuthHdrs();
      const response = await fetch(`${config.apiURL}application/change-advisor`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${hdrs.token}`,
        },
        body: formData,
      });

      let outcome;
      try {
        outcome = await response.json();
      } catch (e) {
        outcome = null;
      }

      if (!response.ok) {
        const errorMsg =
          (outcome && outcome.data && outcome.data.error) ||
          (outcome && outcome.error) ||
          'Failed to change advisor.';
        comp.errorBox('Error', errorMsg);
        return;
      }

      if (outcome && outcome.status === 'OK') {
        comp.toast(outcome.status);
        thsPage.vars.overview_target_advisor = '';
        thsPage.vars.overview_target_advisor_text = '';
        this.clearOverviewChangeAdvisorFile();
        await this.render();
      } else {
        comp.errorBox(
          'Error',
          (outcome && outcome.data && outcome.data.error) || 'Failed to change advisor.'
        );
      }
    } catch (error) {
      comp.errorBox('Error', 'Failed to change advisor. Please try again.');
    } finally {
      this.updateOverviewChangeAdvisorButtonVisibility();
    }
  },
  
  async updateImportedWillNumber() {
    const importedWillNumberInput = U.id('importWillNumber');
    if (!importedWillNumberInput) {
      comp.errorBox('Error', 'Imported will number input not found.');
      return;
    }
    
    const importedWillNumber = importedWillNumberInput.value.trim();
    
    // Note: Allowing empty value since imported will number might be cleared
    // Clear any previous error styling
    importedWillNumberInput.classList.remove('input-error');
    
    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.will_number = importedWillNumber;
    
    try {
      const response = await O.PREP([await O.mPOST('application/ups-importwillnumber', vars)]);
      const result = response['application/ups-importwillnumber'];
      
      if (result.status === 'OK') {
        comp.toast('Imported will number updated successfully');
        // Reload the page to refresh data
        await this.render();
      } else {
        comp.errorBox('Error', result.message || 'Failed to update imported will number');
      }
    } catch (error) {
      comp.errorBox('Error', 'Failed to update imported will number. Please try again.');
    }
  },

  inviteParties(appSummaryData) {
    const parties = [];
    for (let n = 1; n <= 5; n++) {
      const name = appSummaryData[`party${n}_full_name`];
      if (name == null || String(name).trim() === '') {
        continue;
      }
      const userUuid = appSummaryData[`party${n}_user_uuid`];
      parties.push({
        partyNumber: n,
        name: String(name).trim(),
        userUuid: userUuid != null && String(userUuid).trim() !== '' ? String(userUuid).trim() : '',
      });
    }
    return parties;
  },

  async renderInviteClientFulfillment(appSummaryData) {
    const section = U.id('inviteClientFulfillmentSection');
    const fields = U.id('inviteClientFulfillmentFields');
    if (!section || !fields) {
      return;
    }

    fields.innerHTML = '';
    const statusText = String(appSummaryData?.status || '').trim();
    if (!O.canInviteClientFulfillment() || statusText !== 'In progress') {
      U.hide('inviteClientFulfillmentSection');
      return;
    }

    const emailRow = document.createElement('div');
    emailRow.className = 'flex flex-wrap items-start gap-8 w-full';

    const emailField = await comp.inputEmail('inviteClientEmail', '', 'Email address', 1);
    emailField.style.flex = '1 1 16rem';
    emailField.style.maxWidth = '24rem';
    emailRow.appendChild(emailField);

    const partyColumn = document.createElement('div');
    partyColumn.className = 'flex flex-col gap-2';
    partyColumn.id = 'inviteClientPartyDiv';

    const partyLabel = document.createElement('span');
    partyLabel.className = 'block text-left font-medium';
    partyLabel.textContent = 'Party';
    partyColumn.appendChild(partyLabel);

    const parties = this.inviteParties(appSummaryData || {});
    if (!parties.length) {
      const empty = document.createElement('p');
      empty.className = 'text-sm text-gray-600';
      empty.textContent = 'No parties on this application';
      partyColumn.appendChild(empty);
    } else {
      parties.forEach((party) => {
        if (!party.userUuid) {
          return;
        }
        const label = document.createElement('label');
        label.className = 'flex items-center gap-2';
        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'inviteClientParty';
        radio.value = party.userUuid;
        radio.dataset.partyNumber = String(party.partyNumber);
        radio.required = true;
        const text = document.createElement('span');
        text.textContent = party.name;
        label.appendChild(radio);
        label.appendChild(text);
        partyColumn.appendChild(label);
      });
    }

    const partyFeedback = document.createElement('span');
    partyFeedback.setAttribute('fb-for', 'inviteClientParty');
    partyFeedback.className = 'text-error text-xs font-light';
    partyColumn.appendChild(partyFeedback);
    emailRow.appendChild(partyColumn);
    fields.appendChild(emailRow);

    const guidanceField = await comp.textarea(
      'inviteClientGuidance',
      '',
      'Instructions/guidance for this client',
      1
    );
    fields.appendChild(guidanceField);

    const button = document.createElement('button');
    button.type = 'button';
    button.id = 'inviteClientFulfillmentBtn';
    button.className = 'btn';
    button.textContent = 'Email invitation to client';
    button.setAttribute('onclick', 'thsTab.emailClientInvitation()');
    fields.appendChild(button);

    U.unhide('inviteClientFulfillmentSection');
  },

  async emailClientInvitation() {
    const emailInput = U.id('inviteClientEmail');
    if (!emailInput) {
      comp.errorBox('Error', 'Email address input not found.');
      return;
    }

    const emailAddress = emailInput.value.trim();
    emailInput.classList.remove('input-error');
    const emailFeedback = document.querySelector('[fb-for="inviteClientEmail"]');
    if (emailFeedback) {
      emailFeedback.textContent = '';
    }

    const guidanceInput = U.id('inviteClientGuidance');
    const guidance = guidanceInput ? guidanceInput.value.trim() : '';
    if (guidanceInput) {
      guidanceInput.classList.remove('input-error');
    }
    const guidanceFeedback = document.querySelector('[fb-for="inviteClientGuidance"]');
    if (guidanceFeedback) {
      guidanceFeedback.textContent = '';
    }

    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddress);
    const guidanceOk = guidance !== '';
    const selectedParty = document.querySelector('input[name="inviteClientParty"]:checked');
    const partyFeedback = document.querySelector('[fb-for="inviteClientParty"]');
    if (partyFeedback) {
      partyFeedback.textContent = '';
    }

    if (!emailOk) {
      emailInput.classList.add('input-error');
      if (emailFeedback) {
        emailFeedback.textContent = 'Please enter a valid email address';
      }
    }
    if (!guidanceOk && guidanceInput) {
      guidanceInput.classList.add('input-error');
      if (guidanceFeedback) {
        guidanceFeedback.textContent = 'Instructions/guidance for this client is required';
      }
    }
    if (!selectedParty) {
      if (partyFeedback) {
        partyFeedback.textContent = 'Choose which party this email address is for';
      }
    }
    if (!emailOk || !guidanceOk || !selectedParty) {
      comp.errorBox('Missing input', 'Email address, instructions, and a party are required.');
      return;
    }

    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.party_uuid = selectedParty.value;
    vars.email_address = emailAddress;
    vars.instruction = guidance;

    U.loaderBtn(1, 'inviteClientFulfillmentBtn');
    try {
      const response = await O.PREP([await O.mPOST('application/invite-party-fulfillment', vars)]);
      const result = response['application/invite-party-fulfillment'];
      if (result && result.status === 'OK') {
        comp.toast('Invitation emailed to the client');
        U.loaderBtn(0, 'inviteClientFulfillmentBtn');
        await this.render();
      } else {
        U.loaderBtn(0, 'inviteClientFulfillmentBtn');
        comp.errorBox('Error', (result && (result.message || result.error)) || 'Failed to email the invitation.');
      }
    } catch (error) {
      U.loaderBtn(0, 'inviteClientFulfillmentBtn');
    }
  },

  async updateLastReviewedWithClient() {
    const lastReviewedInput = U.id('lastReviewedWithClient');
    if (!lastReviewedInput) {
      comp.errorBox('Error', 'Last reviewed with client input not found.');
      return;
    }

    const lastReviewedDate = lastReviewedInput.value.trim();
    lastReviewedInput.classList.remove('input-error');

    if (!lastReviewedDate || !/^\d{4}-\d{2}-\d{2}$/.test(lastReviewedDate)) {
      lastReviewedInput.classList.add('input-error');
      comp.errorBox('Missing input', 'Please select a date for Last reviewed with client.');
      return;
    }

    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.reviewed_with_client = lastReviewedDate;

    try {
      const response = await O.PREP([await O.mPOST('application/ups-last-client-review', vars)]);
      const result = response['application/ups-last-client-review'];

      if (result.status === 'OK') {
        comp.toast('Last reviewed with client updated successfully');
        await this.render();
      } else {
        comp.errorBox('Error', result.message || 'Failed to update last reviewed with client');
      }
    } catch (error) {
      comp.errorBox('Error', 'Failed to update last reviewed with client. Please try again.');
    }
  },
  
  async updateWillHistory() {
    const receivedDateInput = U.id('willHistoryReceivedDate');
    const signedDateInput = U.id('willHistorySignedDate');
    const verificationDateInput = U.id('willHistoryVerificationDate');
    const willNotesTextarea = U.id('willHistoryNotes');
    
    if (!receivedDateInput || !signedDateInput || !verificationDateInput || !willNotesTextarea) {
      comp.errorBox('Error', 'Will history form elements not found.');
      return;
    }
    
    // Remove any existing error classes
    receivedDateInput.classList.remove('input-error');
    signedDateInput.classList.remove('input-error');
    verificationDateInput.classList.remove('input-error');
    willNotesTextarea.classList.remove('input-error');
    
    // Validate all fields are filled
    const receivedDate = receivedDateInput.value.trim();
    const signedDate = signedDateInput.value.trim();
    const verificationDate = verificationDateInput.value.trim();
    const willNotes = willNotesTextarea.value.trim();
    
    let isValid = true;
    
    if (!receivedDate) {
      receivedDateInput.classList.add('input-error');
      isValid = false;
    }
    
    if (!signedDate) {
      signedDateInput.classList.add('input-error');
      isValid = false;
    }
    
    if (!verificationDate) {
      verificationDateInput.classList.add('input-error');
      isValid = false;
    }
    
    if (!willNotes) {
      willNotesTextarea.classList.add('input-error');
      isValid = false;
    }
    
    if (!isValid) {
      return;
    }
    
    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.received_date = receivedDate;
    vars.signed_date = signedDate;
    vars.verification_date = verificationDate;
    vars.will_notes = willNotes;
    vars.import_dates_yn = true;
    
    try {
      const response = await O.PREP([await O.mPOST('application/import-will-details', vars)]);
      const result = response['application/import-will-details'];
      
      if (result.status === 'OK') {
        comp.toast('Will history updated successfully');
        // Reload the page to refresh data
        await this.render();
      } else {
        comp.errorBox('Error', result.message || 'Failed to update will history');
      }
    } catch (error) {
      comp.errorBox('Error', 'Failed to update will history. Please try again.');
    }
  },
  
  async removeParty(party_user_uuid, partyName, partyNumber) {
    // Confirm with user before removing party
    const confirmed = confirm(`Are you sure you want to remove ${partyName} from this will?`);
    
    if (!confirmed) {
      return; // User cancelled
    }
    
    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.party = `party${partyNumber}`; // e.g., 'party1', 'party2', etc.
    
    try {
      const response = await O.PREP([await O.mPOST('application/rmv-party', vars)]);
      const result = response['application/rmv-party'];
      
      if (result.status === 'OK') {
        comp.toast('Party removed successfully');
        // Reload the page to refresh data
        await this.render();
      } else {
        comp.errorBox('Error', result.message || 'Failed to remove party');
      }
    } catch (error) {
      comp.errorBox('Error', 'Failed to remove party. Please try again.');
    }
  },
  
  toggleAddNoteForm() {
    const addNoteSection = U.id('addNoteSection');
    if (addNoteSection) {
      const currentDisplay = window.getComputedStyle(addNoteSection).display;
      if (currentDisplay === 'none') {
        addNoteSection.style.display = 'block';
      } else {
        addNoteSection.style.display = 'none';
        // Clear the textarea when hiding
        const textarea = U.id('newNoteTextarea');
        if (textarea) {
          textarea.value = '';
          textarea.classList.remove('input-error');
        }
      }
    }
  },
  
  async toggleAddPartyForm() {
    const addPartyFormContainer = U.id('addPartyFormContainer');
    if (addPartyFormContainer) {
      const currentDisplay = window.getComputedStyle(addPartyFormContainer).display;
      if (currentDisplay === 'none') {
        // Show the form - build it if empty
        if (addPartyFormContainer.innerHTML === '') {
          await this.buildAddPartySection(false, '', true, addPartyFormContainer);
        } else {
          addPartyFormContainer.style.display = 'block';
        }
      } else {
        addPartyFormContainer.style.display = 'none';
        // Clear the form when hiding
        addPartyFormContainer.innerHTML = '';
      }
    }
  },
  
  async addNewNote() {
    const noteTextarea = U.id('newNoteTextarea');
    const noteDetails = noteTextarea ? noteTextarea.value.trim() : '';
    
    // Validate that note is not empty
    if (!noteDetails) {
      comp.toast('Please enter a note before adding.');
      if (noteTextarea) {
        noteTextarea.focus();
        noteTextarea.classList.add('input-error');
      }
      return;
    }
    
    // Clear any previous error styling
    if (noteTextarea) {
      noteTextarea.classList.remove('input-error');
    }
    
    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.note_details = noteDetails;
    
    try {
      const response = await O.PREP([await O.mPOST('application/ins-application-notes', vars)]);
      const result = response['application/ins-application-notes'];
      
      // Check if request was successful (has data indicates success)
      if (result && result.data) {
        comp.toast(result.status || 'Note added successfully');
        // Clear the textarea
        if (noteTextarea) {
          noteTextarea.value = '';
        }
        // Hide the form
        const addNoteSection = U.id('addNoteSection');
        if (addNoteSection) {
          addNoteSection.style.display = 'none';
        }
        // Reload the page to refresh data
        await this.render();
      } else {
        comp.errorBox('Error', result.message || result.status || 'Failed to add note');
      }
    } catch (error) {
      comp.errorBox('Error', 'Failed to add note. Please try again.');
    }
  },
  
  toggleDiscountTextarea() {
    const checkbox = U.id('finalDiscountYN');
    const formContainer = U.id('discountFormContainer');
    
    if (checkbox && formContainer) {
      if (checkbox.checked) {
        // Show textarea and button
        formContainer.style.display = 'block';
        const textarea = U.id('finalDiscountDescription');
        if (textarea) {
          textarea.disabled = false;
          textarea.focus(); // Focus the textarea when shown
        }
      } else {
        // Hide textarea and button
        formContainer.style.display = 'none';
        const textarea = U.id('finalDiscountDescription');
        if (textarea) {
          textarea.value = ''; // Clear the textarea when unchecked
          textarea.classList.remove('input-error'); // Clear any error styling
        }
      }
    }
  },
  
  async recordDiscountArrangement() {
    const checkbox = U.id('finalDiscountYN');
    const textarea = U.id('finalDiscountDescription');
    
    if (!checkbox || !textarea) {
      comp.errorBox('Error', 'Discount form elements not found.');
      return;
    }
    
    // Validate that checkbox is checked
    if (!checkbox.checked) {
      comp.toast('Please check "Discount arranged" before recording.');
      return;
    }
    
    const arrangementDescription = textarea.value.trim();
    
    // Validate that there is at least some entry in the textarea
    if (!arrangementDescription) {
      comp.toast('Please enter discount arrangement details.');
      textarea.focus();
      textarea.classList.add('input-error');
      return;
    }
    
    // Clear any previous error styling
    textarea.classList.remove('input-error');
    
    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.arrangement_description = arrangementDescription;
    
    try {
      const response = await O.PREP([await O.mPOST('application/ups-discount-arrangement', vars)]);
      const result = response['application/ups-discount-arrangement'];
      
      // Check if request was successful (has data indicates success)
      if (result && result.data) {
        comp.toast(result.status || 'Discount arrangement recorded successfully');
        // Reload the page to refresh data
        await this.render();
      } else {
        comp.errorBox('Error', result.message || result.status || 'Failed to record discount arrangement');
      }
    } catch (error) {
      comp.errorBox('Error', 'Failed to record discount arrangement. Please try again.');
    }
  },
  
  async buildAddPartySection(showNameFields = false, savedInputValue = '', savedToggleState = true, container = null) {
    // Use provided container or fall back to addPartySection
    const addPartySection = container || U.id('addPartySection');
    if (!addPartySection) {
      return;
    }
    addPartySection.innerHTML = '';
    addPartySection.style.display = 'block'; // Show when building
    
    // Create container for the add party form
    const formContainer = document.createElement('div');
    formContainer.className = '';
    
    // Create form wrapper - always horizontal layout
    const formDiv = document.createElement('div');
    formDiv.id = 'addPartyForm';
    formDiv.className = 'flex items-end gap-4'; // Changed to items-end for better alignment
    formDiv.style.alignItems = 'flex-end'; // Ensure all items align at bottom
    
    // Add ID/Passport input with toggle and magic wand - restore saved values
    const partyIDPass = await comp.inputIDPassport('newPartyIDPass', savedToggleState ? 1 : 0, savedInputValue, 1);
    
    // Extract toggle and label elements
    const toggleSwitch = partyIDPass.querySelector('.switch');
    const toggleLabel = partyIDPass.querySelector('#newPartyIDPass_toggle_label');
    const magicWandContainer =
      partyIDPass.querySelector('#newPartyIDPass_autofill_icon')?.parentElement ??
      partyIDPass.querySelector('#newPartyIDPass_toggle_label')?.parentElement;
    
    // Extract input field and its container
    const inputGroup = partyIDPass.querySelector('.input-group');
    const inputField = partyIDPass.querySelector('#newPartyIDPass');
    
    // Restore toggle state if provided
    const toggleInput = partyIDPass.querySelector('#newPartyIDPass_toggle');
    if (toggleInput && savedToggleState !== undefined) {
      toggleInput.checked = savedToggleState;
      // Update label text to match toggle state
      if (toggleLabel) {
        toggleLabel.textContent = savedToggleState ? 'ID Number' : 'Passport Number';
      }
    }
    
    // Set input field width and restore value if provided
    if (inputField) {
      inputField.style.width = '20ch';
      inputField.style.maxWidth = '20ch';
      inputField.style.height = '32px'; // Set consistent height
      inputField.style.boxSizing = 'border-box';
      // Restore saved input value if provided
      if (savedInputValue) {
        inputField.value = savedInputValue;
      }
    }
    
    // Ensure the input-group container aligns properly
    if (inputGroup) {
      inputGroup.style.display = 'flex';
      inputGroup.style.flexDirection = 'column';
      // Find the label in inputGroup and ensure consistent spacing
      const inputGroupLabel = inputGroup.querySelector('label');
      if (inputGroupLabel) {
        inputGroupLabel.style.marginBottom = '0.25rem'; // Match other labels
        inputGroupLabel.style.height = 'auto';
      }
      // Ensure input field has no top margin
      if (inputField) {
        inputField.style.marginTop = '0';
      }
    }
    
    // Create horizontal container for toggle, label, and magic wand
    const toggleLabelContainer = document.createElement('div');
    toggleLabelContainer.className = 'flex items-center gap-2';
    toggleLabelContainer.style.alignSelf = 'flex-start'; // Align toggle to top
    toggleLabelContainer.style.height = '1.5rem'; // Fixed height to match label height
    toggleLabelContainer.style.marginBottom = '0.25rem'; // Match label spacing
    if (toggleSwitch) {
      toggleLabelContainer.appendChild(toggleSwitch);
    }
    if (toggleLabel) {
      toggleLabelContainer.appendChild(toggleLabel);
    }
    if (magicWandContainer) {
      toggleLabelContainer.appendChild(magicWandContainer);
    }
    
    // Create wrapper for ID/Passport section to match Name/Surname structure
    const idPassWrapper = document.createElement('div');
    idPassWrapper.style.display = 'flex';
    idPassWrapper.style.flexDirection = 'column';
    idPassWrapper.appendChild(toggleLabelContainer);
    if (inputGroup) {
      idPassWrapper.appendChild(inputGroup);
    }
    
    // Add wrapper to formDiv
    formDiv.appendChild(idPassWrapper);
    
    // Add Name and Surname fields if showNameFields is true
    if (showNameFields) {
      const nameInput = await comp.inputText('newPartyName', '', 'Name', 1);
      nameInput.style.width = '20ch';
      nameInput.style.minWidth = '20ch';
      nameInput.style.display = 'flex';
      nameInput.style.flexDirection = 'column';
      // Ensure the input field inside is aligned
      const nameInputField = nameInput.querySelector('input');
      const nameLabel = nameInput.querySelector('label');
      if (nameInputField) {
        nameInputField.style.height = '32px'; // Match ID input height
        nameInputField.style.boxSizing = 'border-box';
        nameInputField.style.marginTop = '0';
      }
      if (nameLabel) {
        nameLabel.style.marginBottom = '0.25rem'; // Consistent label spacing
      }
      formDiv.appendChild(nameInput);
      
      const surnameInput = await comp.inputText('newPartySurname', '', 'Surname', 1);
      surnameInput.style.width = '20ch';
      surnameInput.style.minWidth = '20ch';
      surnameInput.style.display = 'flex';
      surnameInput.style.flexDirection = 'column';
      // Ensure the input field inside is aligned
      const surnameInputField = surnameInput.querySelector('input');
      const surnameLabel = surnameInput.querySelector('label');
      if (surnameInputField) {
        surnameInputField.style.height = '32px'; // Match ID input height
        surnameInputField.style.boxSizing = 'border-box';
        surnameInputField.style.marginTop = '0';
      }
      if (surnameLabel) {
        surnameLabel.style.marginBottom = '0.25rem'; // Consistent label spacing
      }
      formDiv.appendChild(surnameInput);
      
      // Add "Append new party to application" button to the right of Surname
      const appendButton = document.createElement('button');
      appendButton.textContent = 'Append new party to application';
      appendButton.className = 'btn';
      appendButton.id = 'appendPartyBtn';
      appendButton.style.height = '32px'; // Match input height
      appendButton.style.boxSizing = 'border-box';
      appendButton.style.alignSelf = 'flex-start'; // Align to top
      appendButton.style.marginTop = '1.75rem'; // Match label height (1.5rem) + label margin-bottom (0.25rem) to align with inputs
      appendButton.setAttribute('onclick', 'thsTab.appendNewParty()');
      formDiv.appendChild(appendButton);
    } else {
      // Add Continue button horizontally next to the ID/Passport input
      const continueButton = document.createElement('button');
      continueButton.textContent = 'Continue';
      continueButton.className = 'btn';
      continueButton.id = 'addPartyContinueBtn';
      continueButton.style.height = '32px'; // Match input height
      continueButton.style.boxSizing = 'border-box';
      continueButton.style.alignSelf = 'flex-start'; // Align to top
      continueButton.style.marginTop = '1.75rem'; // Match label height (1.5rem) + label margin-bottom (0.25rem) to align with inputs
      continueButton.setAttribute('onclick', 'thsTab.addNewParty()');
      formDiv.appendChild(continueButton);
    }
    
    formContainer.appendChild(formDiv);
    addPartySection.appendChild(formContainer);
  },
  
  async addNewParty() {
    // Validate the form
    const isValid = await U.validateForm('addPartyForm');
    if (!isValid) {
      return;
    }
    
    const idPassInput = U.id('newPartyIDPass');
    const idToggle = U.id('newPartyIDPass_toggle');
    
    // Save the input value and toggle state before making the request
    const savedInputValue = idPassInput.value.trim();
    const savedToggleState = idToggle ? idToggle.checked : true;
    
    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.id_pass = savedInputValue;
    
    try {
      const response = await O.PREP([await O.mPOST('application/ver-append-user', vars)]);
      const result = response['application/ver-append-user'];
      
      if (result.status === 'OK') {
        // Get the container where the form should be displayed
        const addPartyFormContainer = U.id('addPartyFormContainer');
        const container = addPartyFormContainer || U.id('addPartySection');
        
        // Check if response is an array of users
        if (Array.isArray(result.data) && result.data.length > 0) {
          // Display table of matching users
          await this.buildMatchingUsersTable(result.data, savedInputValue, savedToggleState, container);
        } else if (result.data === 'No party found') {
          // Remove Continue button and show Name and Surname fields with Append button
          // Preserve the input value and toggle state
          await this.buildAddPartySection(true, savedInputValue, savedToggleState, container);
        } else {
          comp.toast('Party added successfully');
          // Reload the page to refresh data
          await this.render();
        }
      } else {
        comp.errorBox('Error', result.message || 'Failed to add party');
      }
    } catch (error) {
      comp.errorBox('Error', 'Failed to add party. Please try again.');
    }
  },
  
  async buildMatchingUsersTable(users, savedInputValue, savedToggleState, container = null) {
    // Use provided container or fall back to addPartySection
    const addPartySection = container || U.id('addPartySection');
    if (!addPartySection) {
      return;
    }
    
    // Clear existing content
    addPartySection.innerHTML = '';
    addPartySection.style.display = 'block'; // Show when building
    
    // Create container for the form and table
    const formContainer = document.createElement('div');
    formContainer.className = '';
    
    // Create form wrapper
    const formDiv = document.createElement('div');
    formDiv.id = 'addPartyForm';
    formDiv.className = 'flex flex-col items-start gap-4';
    
    // Add ID/Passport input with toggle and magic wand - restore saved values
    const partyIDPass = await comp.inputIDPassport('newPartyIDPass', savedToggleState ? 1 : 0, savedInputValue, 1);
    
    // Set input field width to 20 characters and restore value if provided
    const inputField = partyIDPass.querySelector('#newPartyIDPass');
    if (inputField) {
      inputField.style.width = '20ch';
      inputField.style.maxWidth = '20ch';
      // Restore saved input value if provided
      if (savedInputValue) {
        inputField.value = savedInputValue;
      }
    }
    
    // Restore toggle state if provided
    const toggleInput = partyIDPass.querySelector('#newPartyIDPass_toggle');
    const toggleLabel = partyIDPass.querySelector('#newPartyIDPass_toggle_label');
    if (toggleInput && savedToggleState !== undefined) {
      toggleInput.checked = savedToggleState;
      // Update label text to match toggle state
      if (toggleLabel) {
        toggleLabel.textContent = savedToggleState ? 'ID Number' : 'Passport Number';
      }
    }
    
    // Rearrange the layout so label is next to toggle
    const toggleContainer = partyIDPass.querySelector('.flex.items-center.justify-between');
    if (toggleContainer) {
      toggleContainer.className = 'flex items-center gap-2';
      // Move label to be right after toggle
      const toggleSwitch = partyIDPass.querySelector('.switch');
      const magicWandContainer =
        partyIDPass.querySelector('#newPartyIDPass_autofill_icon')?.parentElement ??
        partyIDPass.querySelector('#newPartyIDPass_toggle_label')?.parentElement;
      
      if (toggleLabel && toggleSwitch && magicWandContainer) {
        // Remove from current parent
        magicWandContainer.removeChild(toggleLabel);
        // Insert label right after toggle
        toggleSwitch.parentNode.insertBefore(toggleLabel, toggleSwitch.nextSibling);
        // Add magic wand container back
        toggleContainer.appendChild(magicWandContainer);
      }
    }
    
    formDiv.appendChild(partyIDPass);
    formContainer.appendChild(formDiv);
    
    // Create table for matching users - match styling of existing parties table
    const tableContainer = document.createElement('div');
    tableContainer.className = 'mt-4 w-full';
    tableContainer.style.overflowX = 'auto';
    
    const table = U.divAtt('table');
    table.style.width = '1200px';
    table.style.tableLayout = 'fixed'; // Use fixed layout for consistent column widths
    
    // HEADER - match styling of existing parties table
    const thead = U.divAtt('thead');
    const headRow = thead.insertRow();
    
    const headers = ['Name', 'Email', 'ID no', 'Passport', 'Created', 'Status', 'Notes', 'Action'];
    // Calculate column widths: Email is 50% wider than others, then another 50% wider (2.25x base)
    const baseColumnWidth = Math.floor(1200 / (headers.length + 1.25)); // +1.25 accounts for Email being 2.25x wider
    const emailColumnWidth = Math.floor(baseColumnWidth * 2.25); // 50% wider than 1.5x (which is 2.25x base)
    const otherColumnWidth = Math.floor((1200 - emailColumnWidth) / (headers.length - 1));
    
    headers.forEach((headerText, index) => {
      const th = headRow.insertCell();
      th.innerHTML = headerText;
      // Email column (index 1) gets the wider width
      th.style.width = index === 1 ? `${emailColumnWidth}px` : `${otherColumnWidth}px`;
      th.style.verticalAlign = 'top';
      // Prevent overflow for Email column
      if (index === 1) {
        th.style.wordWrap = 'break-word';
        th.style.overflowWrap = 'break-word';
        th.style.wordBreak = 'break-all';
        th.style.maxWidth = `${emailColumnWidth}px`;
      }
    });
    
    table.appendChild(thead);
    
    // BODY - match styling of existing parties table
    const tbody = U.divAtt('tbody');
    for (const user of users) {
      const row = tbody.insertRow();
      
      // Name column (f_name and s_name)
      const nameCell = row.insertCell(0);
      nameCell.style.verticalAlign = 'top';
      nameCell.innerHTML = `${user.f_name || ''} ${user.s_name || ''}`.trim();
      
      // Email column (email_address)
      const emailCell = row.insertCell(1);
      emailCell.style.verticalAlign = 'top';
      emailCell.style.wordWrap = 'break-word';
      emailCell.style.overflowWrap = 'break-word';
      emailCell.style.wordBreak = 'break-all';
      emailCell.style.maxWidth = `${emailColumnWidth}px`;
      emailCell.innerHTML = user.email_address || '';
      
      // ID no column (id_nr)
      const idCell = row.insertCell(2);
      idCell.style.verticalAlign = 'top';
      idCell.innerHTML = user.id_nr || '';
      
      // Passport column (passport_nr)
      const passportCell = row.insertCell(3);
      passportCell.style.verticalAlign = 'top';
      passportCell.innerHTML = user.passport_nr || '';
      
      // Created column (created_date)
      const dateCell = row.insertCell(4);
      dateCell.style.verticalAlign = 'top';
      dateCell.innerHTML = user.created_date ? await U.formatDate(user.created_date) : '';
      
      // Status column (party_status)
      const statusCell = row.insertCell(5);
      statusCell.style.verticalAlign = 'top';
      statusCell.innerHTML = user.party_status || '';
      
      // Notes column (party_notes)
      const notesCell = row.insertCell(6);
      notesCell.style.verticalAlign = 'top';
      notesCell.innerHTML = user.party_notes || '';
      
      // Action column with Append button
      const actionCell = row.insertCell(7);
      actionCell.style.verticalAlign = 'top';
      const appendButton = document.createElement('button');
      appendButton.textContent = 'Append party';
      appendButton.className = 'btn';
      appendButton.setAttribute('onclick', `thsTab.appendUserToApplication('${user.user_uuid}')`);
      actionCell.appendChild(appendButton);
    }
    
    table.appendChild(tbody);
    tableContainer.appendChild(table);
    formContainer.appendChild(tableContainer);
    
    addPartySection.appendChild(formContainer);
  },
  
  async appendUserToApplication(user_uuid) {
    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.party_uuid = user_uuid;
    
    try {
      const response = await O.PREP([await O.mPOST('application/append-new-party', vars)]);
      const result = response['application/append-new-party'];
      
      if (result.status === 'OK') {
        comp.toast('Party added successfully');
        // Reload the page to refresh data
        await this.render();
      } else {
        comp.errorBox('Error', result.message || 'Failed to add party');
      }
    } catch (error) {
      comp.errorBox('Error', 'Failed to add party. Please try again.');
    }
  },
  
  async appendNewParty() {
    // Validate the form
    const isValid = await U.validateForm('addPartyForm');
    if (!isValid) {
      return;
    }
    
    const idPassInput = U.id('newPartyIDPass');
    const idToggle = U.id('newPartyIDPass_toggle');
    const nameInput = U.id('newPartyName');
    const surnameInput = U.id('newPartySurname');
    
    // Determine reference_type based on toggle state
    const isIDNumber = idToggle ? idToggle.checked : true;
    
    const vars = {};
    vars.application_uuid = this.application_uuid;
    vars.reference_type = isIDNumber ? 'id_nr' : 'passport_nr';
    vars.reference_number = idPassInput.value.trim();
    vars.f_name = nameInput.value.trim();
    vars.s_name = surnameInput.value.trim();
    
    try {
      const response = await O.PREP([await O.mPOST('application/append-new-party', vars)]);
      const result = response['application/append-new-party'];
      
      if (result.status === 'OK') {
        comp.toast('Party added successfully');
        // Reload the page to refresh data
        await this.render();
      } else {
        comp.errorBox('Error', result.message || 'Failed to add party');
      }
    } catch (error) {
      comp.errorBox('Error', 'Failed to add party. Please try again.');
    }
  },
  
  showCancelInput() {
    const statusActions = U.id('status_actions');
    
    // Check if input already exists
    if (U.id('cancelReasonInput')) {
      return; // Already shown
    }
    
    // Create input element
    const input = document.createElement('input');
    input.type = 'text';
    input.id = 'cancelReasonInput';
    input.placeholder = 'Enter cancellation reason';
    input.style.marginRight = '10px';
    input.style.padding = '8px';
    input.style.border = '1px solid #ccc';
    input.style.borderRadius = '4px';
    input.style.minWidth = '300px';
    
    // Insert input before the Cancel button
    const cancelButton = statusActions.querySelector('button');
    if (cancelButton) {
      statusActions.insertBefore(input, cancelButton);
      
      // Add event listener to monitor character count and change button color
      input.addEventListener('input', () => {
        const reasonLength = input.value.trim().length;
        
        if (reasonLength >= 10) {
          // Change button color to red when 10+ characters
          cancelButton.style.backgroundColor = '#dc3545'; // Red color
          cancelButton.style.color = '#fff';
          cancelButton.style.borderColor = '#dc3545';
        } else {
          // Revert to original button style when less than 10 characters
          cancelButton.style.backgroundColor = '';
          cancelButton.style.color = '';
          cancelButton.style.borderColor = '';
        }
      });
      
      // Update button onclick to call cancel function
      cancelButton.setAttribute('onclick', `thsTab.cancelApplicationWithReason('${this.application_uuid}')`);
    } else {
      statusActions.appendChild(input);
    }
  },
  
  async cancelApplicationWithReason(application_uuid) {
    const cancelReasonInput = U.id('cancelReasonInput');
    const cancelReason = cancelReasonInput ? cancelReasonInput.value.trim() : '';
    
    // Validate reason length
    if (cancelReason.length < 10) {
      comp.toast('Please enter at least 10 characters for the cancellation reason');
      return;
    }

    const vars = {};
    vars.application_uuid = application_uuid;
    vars.cancel_reason = cancelReason;
    
    try {
      const response = await O.PREP([await O.mPOST('application/cancel-application', vars)]);
      const result = response['application/cancel-application'];
      
      if (result.status === 'OK') {
        comp.toast('Application cancelled successfully');
        // Reload the page to refresh the status
        await this.render();
      } else {
        comp.errorBox('Error', result.message || 'Failed to cancel application');
      }
    } catch (error) {
      comp.errorBox('Error', 'Failed to cancel application. Please try again.');
    }
  },
  
  async toggleAddEstatePlanForm() {
    const addEstatePlanFormContainer = U.id('addEstatePlanFormContainer');
    if (addEstatePlanFormContainer) {
      const currentDisplay = window.getComputedStyle(addEstatePlanFormContainer).display;
      if (currentDisplay === 'none') {
        // Show the form - build it if empty
        if (addEstatePlanFormContainer.innerHTML === '') {
          await this.buildAddEstatePlanForm(addEstatePlanFormContainer);
        } else {
          addEstatePlanFormContainer.style.display = 'block';
        }
      } else {
        addEstatePlanFormContainer.style.display = 'none';
        // Clear the form when hiding
        addEstatePlanFormContainer.innerHTML = '';
      }
    }
  },
  
  async buildAddEstatePlanForm(container) {
    if (!container) {
      container = U.id('addEstatePlanFormContainer');
    }
    if (!container) {
      return;
    }
    
    container.innerHTML = '';
    container.style.display = 'block';
    
    // Create form wrapper
    const formDiv = document.createElement('div');
    formDiv.id = 'addEstatePlanForm';
    formDiv.className = 'space-y-4';
    
    // Container for dropdown and policy number side by side
    const dropdownPolicyContainer = document.createElement('div');
    dropdownPolicyContainer.style.display = 'flex';
    dropdownPolicyContainer.style.gap = '1rem';
    dropdownPolicyContainer.style.alignItems = 'flex-end';
    
    // Underwriter section with label above dropdown
    const underwriterWrapper = document.createElement('div');
    underwriterWrapper.style.display = 'flex';
    underwriterWrapper.style.flexDirection = 'column';
    
    // Label above dropdown
    const underwriterLabel = document.createElement('label');
    underwriterLabel.setAttribute('for', 'estatePlanUnderwriter');
    underwriterLabel.textContent = 'Underwriter';
    underwriterLabel.className = 'block text-gray-700 font-medium mb-2 text-left';
    underwriterWrapper.appendChild(underwriterLabel);
    
    // Underwriter dropdown - 35 characters wide
    const underwriterSelect = await comp.select_v2({
      elID: 'estatePlanUnderwriter',
      ddData: this.underwriters || [],
      valueDataName: 'underwriter_uuid',
      textDataName: 'underwriter_name',
      labelName: '', // No label since we're adding it above
      requiredYN: true
    });
    // Remove the label from the select component if it exists
    const underwriterSelectLabel = underwriterSelect.querySelector('label');
    if (underwriterSelectLabel) {
      underwriterSelectLabel.remove();
    }
    // Set dropdown width to 35 characters
    const underwriterSelectElement = underwriterSelect.querySelector('#estatePlanUnderwriter');
    if (underwriterSelectElement) {
      underwriterSelectElement.style.width = '35ch';
      underwriterSelectElement.style.minWidth = '35ch';
    }
    underwriterWrapper.appendChild(underwriterSelect);
    dropdownPolicyContainer.appendChild(underwriterWrapper);
    
    // Policy number input - to the right of dropdown
    const policyNumberInput = await comp.inputText('estatePlanPolicyNumber', '', 'Policy number', 1);
    dropdownPolicyContainer.appendChild(policyNumberInput);
    
    formDiv.appendChild(dropdownPolicyContainer);
    
    // Comments textarea
    const commentsTextarea = await comp.textarea('estatePlanComments', '', 'Comments', 1);
    formDiv.appendChild(commentsTextarea);
    
    // Referring document file input
    const fileInput = await comp.inputFile({
      elID: 'estatePlanReferringDocument',
      labelName: 'Referring document',
      accept: '',
      requiredYN: true
    });
    formDiv.appendChild(fileInput);
    
    // Submit button
    const submitButton = document.createElement('button');
    submitButton.textContent = 'Link estate plan to Will';
    submitButton.className = 'btn';
    submitButton.setAttribute('onclick', 'thsTab.linkEstatePlanToWill()');
    submitButton.style.marginTop = '1rem';
    formDiv.appendChild(submitButton);
    
    container.appendChild(formDiv);
  },
  
  async linkEstatePlanToWill() {
    // Validate the form
    const isValid = await U.validateForm('addEstatePlanForm');
    if (!isValid) {
      return;
    }
    
    const underwriterSelect = U.id('estatePlanUnderwriter');
    const policyNumberInput = U.id('estatePlanPolicyNumber');
    const commentsTextarea = U.id('estatePlanComments');
    const fileInput = U.id('estatePlanReferringDocument');
    
    // Additional validation
    if (!underwriterSelect || !underwriterSelect.value) {
      comp.toast('Please select an underwriter');
      if (underwriterSelect) {
        underwriterSelect.classList.add('input-error');
      }
      return;
    }
    
    if (!policyNumberInput || !policyNumberInput.value.trim()) {
      comp.toast('Please enter a policy number');
      if (policyNumberInput) {
        policyNumberInput.classList.add('input-error');
      }
      return;
    }
    
    if (!commentsTextarea || !commentsTextarea.value.trim()) {
      comp.toast('Please enter comments');
      if (commentsTextarea) {
        commentsTextarea.classList.add('input-error');
      }
      return;
    }
    
    if (!fileInput || !fileInput.files || !fileInput.files[0]) {
      comp.toast('Please select a referring document');
      if (fileInput) {
        fileInput.classList.add('input-error');
      }
      return;
    }
    
    // Clear any previous error styling
    if (underwriterSelect) underwriterSelect.classList.remove('input-error');
    if (policyNumberInput) policyNumberInput.classList.remove('input-error');
    if (commentsTextarea) commentsTextarea.classList.remove('input-error');
    if (fileInput) fileInput.classList.remove('input-error');
    
    // Create FormData for file upload (multipart/form-data)
    const formData = new FormData();
    formData.append('application_uuid', this.application_uuid);
    formData.append('underwriter_uuid', underwriterSelect.value);
    formData.append('policy_number', policyNumberInput.value.trim());
    formData.append('comments', commentsTextarea.value.trim());
    formData.append('file', fileInput.files[0]);
    
    const hdrs = await O.getAuthHdrs();
    
    try {
      const response = await fetch(`${config.apiURL}application/ins-estate-plan`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${hdrs.token}`,
        },
        body: formData,
      });
      
      if (!response.ok) {
        throw new Error('Failed to link estate plan');
      }
      
      const result = await response.json();
      
      if (result.status === 'OK') {
        comp.toast('Estate plan linked successfully');
        // Clear the form
        const formContainer = U.id('addEstatePlanFormContainer');
        if (formContainer) {
          formContainer.innerHTML = '';
          formContainer.style.display = 'none';
        }
        // Reload the page to refresh data and show the new product in the list
        await this.render();
      } else {
        comp.errorBox('Error', result.message || 'Failed to link estate plan');
      }
    } catch (error) {
      comp.errorBox('Error', 'Failed to link estate plan. Please try again.');
    }
  },
  
  async downloadFile(file_uuid) {
    const vars = {};
    vars.file_uuid = file_uuid;

    O.PREP([await O.mPOST('files/get-file-url', vars)])
      .then(async (res) => {
        window.open(res['files/get-file-url'].data.signedUrl, '_blank');
      })
      .catch(() => {
        comp.errorBox('Error', 'Failed to download file. Please try again.');
      });
  },

  renderApplicationViewFlag(container) {
    if (!container) return;

    const existing = container.querySelector('[data-app-view-flag-wrap]');
    if (existing) existing.remove();

    const isFlagged = this.flaggedYn;
    const flagSize = 40;
    const flagWrap = document.createElement('div');
    flagWrap.setAttribute('data-app-view-flag-wrap', '1');
    flagWrap.style.display = 'inline-flex';
    flagWrap.style.alignItems = 'center';
    flagWrap.style.gap = '0.35rem';
    flagWrap.style.flexShrink = '0';

    const flagIcon = svg.flag(flagSize, {outline: !isFlagged});
    flagIcon.setAttribute('data-app-view-flag', '1');
    flagIcon.style.cursor = 'pointer';
    flagIcon.style.flexShrink = '0';
    flagIcon.style.width = `${flagSize}px`;
    flagIcon.style.height = `${flagSize}px`;
    flagIcon.style.minWidth = `${flagSize}px`;
    flagIcon.style.minHeight = `${flagSize}px`;
    flagIcon.style.color = isFlagged ? '#3B71CA' : '#717171';
    if (isFlagged) flagIcon.classList.add('text-primary');
    flagIcon.title = isFlagged ? 'Remove flag' : 'Add flag';
    flagIcon.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (isFlagged) {
        this.promptRemoveApplicationViewFlag(container);
      } else {
        this.addApplicationViewFlag(container);
      }
    });
    flagWrap.appendChild(flagIcon);

    const flagLabel = document.createElement('span');
    flagLabel.className = 'text-sm whitespace-nowrap';
    flagLabel.style.color = isFlagged ? '#3B71CA' : '#717171';
    flagLabel.textContent = isFlagged ? 'Flagged' : 'Not flagged';
    flagWrap.appendChild(flagLabel);

    container.appendChild(flagWrap);
  },

  clearPendingFlagRemoval() {
    this._flagRemovalContainer = null;
  },

  async promptRemoveApplicationViewFlag(container) {
    if (!this.flaggedYn) return;
    this._flagRemovalContainer = container || U.id('status_row');
    await comp.modal(
      'Remove flag',
      'Are you sure you want to remove this flag?',
      'thsTab.removeApplicationViewFlag()',
      'thsTab.clearPendingFlagRemoval()'
    );
  },

  async refreshApplicationViewFlagState() {
    const vars = {application_uuid: this.application_uuid};
    const res = await O.PREP([await O.mPOST('application/get-app-summary', vars)]);
    const data = res['application/get-app-summary']?.data;
    const uuid = data?.log_application_view_uuid;
    this.logApplicationViewUuid =
      uuid != null && String(uuid).trim() !== '' ? String(uuid).trim() : null;
    this.flaggedYn =
      data?.flagged_yn === true || data?.flagged_yn === 'true' || data?.flagged_yn === 1;
  },

  async addApplicationViewFlag(container) {
    const vars = {
      log_application_view_uuid: this.logApplicationViewUuid,
      true_false: true,
    };

    try {
      const res = await O.PREP([await O.mPOST('application/upd-application-view-flag', vars)]);
      const payload = res['application/upd-application-view-flag'];
      const newUuid = payload?.data?.log_application_view_uuid ?? payload?.log_application_view_uuid;
      if (newUuid != null && String(newUuid).trim() !== '') {
        this.logApplicationViewUuid = String(newUuid).trim();
      } else {
        await this.refreshApplicationViewFlagState();
      }
      this.flaggedYn = true;
      this.renderApplicationViewFlag(container || U.id('status_row'));
    } catch (error) {
      comp.errorBox('Error', 'Failed to add flag. Please try again.');
    }
  },

  async removeApplicationViewFlag() {
    if (!this.flaggedYn) return;

    const vars = {
      log_application_view_uuid: this.logApplicationViewUuid,
      true_false: false,
    };

    try {
      await O.PREP([await O.mPOST('application/upd-application-view-flag', vars)]);
      this.flaggedYn = false;
      this.renderApplicationViewFlag(this._flagRemovalContainer || U.id('status_row'));
      this._flagRemovalContainer = null;
    } catch (error) {
      comp.errorBox('Error', 'Failed to remove flag. Please try again.');
    }
  },
};
